import AffidavitPDF from "../assets/documents/Affidavit.pdf";
import CACertificatePDF from "../assets/documents/CA_Certificate.pdf";
import CEArchitectPDF from "../assets/documents/CEArchitechCertificate.pdf";
import { incentiveClaimTypes, incentiveClaimTypesList } from "../config/applicationStatusConfig";
import { uttarakhandDistrictList } from "../config/districtConfig";
import { allNicOptions, sourceofFinanceTitle } from "../config/incentiveClaimFormUtils";
import { getLocalDate } from "../utils/utils";

export const applyIncentiveClaimFields = [
  {
    title: {
      en: "",
      hi: "",
    },
    fields: [
      {
        divClass: "w-full lg:w-100 px-2 mb-4",
        label: {
          en: "Financial Incentive Claim",
          hi: "वित्तीय प्रोत्साहन दावा",
        },
        htmlFor: "financial_incentive_claim",
        inputProps: {
          id: "financial_incentive_claim",
          name: "financial_incentive_claim",
          type: "select",
          placeholder: {
            en: "Select Financial Incentive Claim",
            hi: "वित्तीय प्रोत्साहन दावा चुनें",
          },
          options: incentiveClaimTypesList.filter(
            (i) =>
              i.value ===
              incentiveClaimTypes.sreimbursementcapitalincentive.value
          ),
          disabled: false,
          validation: {
            required: true,
            message: {
              en: "Please select Financial Incentive Claim.",
              hi: "कृपया वित्तीय प्रोत्साहन दावा चुनें।",
            },
          },
        },
      },
    ],
  },
];

export const incentiveClaimSection1 = [
  {
    title: "Tourism Unit Detail",
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Unit / Organization Name",
          hi: "इकाई / संगठन का नाम",
        },
        htmlFor: "unit_name",
        inputProps: {
          id: "unit_name",
          name: "unit_name",
          type: "text",
          placeholder: {
            en: "Enter Unit / Organization Name",
            hi: "इकाई / संगठन का नाम दर्ज करें",
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Unit / Organization Name is required.",
              hi: "इकाई / संगठन का नाम आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Unit Address",
          hi: "इकाई का पता",
        },
        htmlFor: "unit_address",
        inputProps: {
          id: "unit_address",
          name: "unit_address",
          type: "text",
          placeholder: {
            en: "Block / Tehsil / District",
            hi: "ब्लॉक / तहसील / जिला दर्ज करें",
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Unit Address is required.",
              hi: "इकाई का पता आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Contact No.",
          hi: "संपर्क नंबर",
        },
        htmlFor: "contact_no",
        inputProps: {
          id: "contact_no",
          name: "contact_no",
          type: "text",
          placeholder: {
            en: "Enter mobile number",
            hi: "मोबाइल नंबर दर्ज करें",
          },
          disabled: false,
          required: true,
          maxLength: 10,
          validation: {
            required: true,
            pattern: /^[6-9]\d{9}$/,
            message: {
              en: "Enter a valid 10-digit mobile number.",
              hi: "मान्य 10 अंकों का मोबाइल नंबर दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Registered Office",
          hi: "पंजीकृत कार्यालय",
        },
        htmlFor: "registered_office",
        inputProps: {
          id: "registered_office",
          name: "registered_office",
          type: "text",
          placeholder: {
            en: "Enter registered office address",
            hi: "पंजीकृत कार्यालय का पता दर्ज करें",
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Registered Office is required.",
              hi: "पंजीकृत कार्यालय आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "GST Registration Number",
          hi: "जीएसटी पंजीकरण संख्या",
        },
        htmlFor: "gst_registration_number",
        inputProps: {
          id: "gst_registration_number",
          name: "gst_registration_number",
          type: "text",
          placeholder: {
            en: "Enter GST number",
            hi: "जीएसटी नंबर दर्ज करें",
          },
          disabled: false,
          required: true,
          maxLength: 15,
          validation: {
            required: true,
            pattern:
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            message: {
              en: "Enter a valid GST number.",
              hi: "मान्य जीएसटी नंबर दर्ज करें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Travel Trade Registration Date (COD)",
          hi: "ट्रैवल ट्रेड पंजीकरण तिथि",
        },
        htmlFor: "travel_registration_date",
        inputProps: {
          id: "travel_registration_date",
          name: "travel_registration_date",
          type: "date",
          placeholder: {
            en: "Select registration date",
            hi: "पंजीकरण तिथि चुनें",
          },
          disabled: false,
          max: getLocalDate(),
          required: false,
          validation: {
            required: false,
            message: {
              en: "Please select a valid registration date.",
              hi: "कृपया मान्य पंजीकरण तिथि चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Registration Number (UTTR No.)",
          hi: "पंजीकरण संख्या (UTTR नंबर)",
        },
        htmlFor: "uttr_no",
        inputProps: {
          id: "uttr_no",
          name: "uttr_no",
          type: "text",
          placeholder: {
            en: "Enter UTTR number",
            hi: "UTTR नंबर दर्ज करें",
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
            message: {
              en: "Please enter a valid UTTR number.",
              hi: "कृपया मान्य UTTR नंबर दर्ज करें।",
            },
          },
        },
      },
    ],
  },
  {
    title: {
      en: "Nature of Organization",
      hi: "संगठन का प्रकार",
    },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Nature of Organization",
          hi: "संगठन का प्रकार",
        },
        htmlFor: "nature_of_organization",
        inputProps: {
          id: "nature_of_organization",
          name: "nature_of_organization",
          type: "select",
          placeholder: {
            en: "Select Nature of Organization",
            hi: "संगठन का प्रकार चुनें",
          },
          options: [
            {
              label: "Private Ltd. Company",
              hi: "प्राइवेट लिमिटेड कंपनी",
              value: "Private ltd. Company",
            },
            {
              label: "Partnership Firm",
              hi: "साझेदारी फर्म",
              value: "Partnership Firm",
            },
            {
              label: "Proprietorship Firm",
              hi: "एकल स्वामित्व फर्म",
              value: "Proprietorship Firm",
            },
            {
              label: "Society / Trust",
              hi: "सोसायटी / ट्रस्ट",
              value: "Society Trust",
            },
            {
              label: "Limited Liability Partnership",
              hi: "सीमित दायित्व भागीदारी (LLP)",
              value: "Limited Liability Partnership",
            },
            {
              label: "One Person Company",
              hi: "वन पर्सन कंपनी",
              value: "One Person Company",
            },
          ],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select nature of organization.",
              hi: "कृपया संगठन का प्रकार चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Gender",
          hi: "लिंग",
        },
        htmlFor: "gender",
        inputProps: {
          id: "gender",
          name: "gender",
          type: "select",
          placeholder: {
            en: "Select Gender",
            hi: "लिंग चुनें",
          },
          options: [
            {
              label: "Male",
              hi: "पुरुष",
              value: "Male",
            },
            {
              label: "Female",
              hi: "महिला",
              value: "Female",
            },
            {
              label: "Other",
              hi: "अन्य",
              value: "Other",
            },
          ],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select gender.",
              hi: "कृपया लिंग चुनें।",
            },
          },
        },
      },
    ],
  },
  {
    title: {
      en: "Detail Owner(s) / Promoter(s) / Director(s)",
      hi: "मालिक / प्रमोटर / निदेशक का विवरण",
    },
    fields: [
      {
        divClass: "overflow-auto mb-4 px-2",
        label: "",
        htmlFor: "investor_details",
        inputProps: {
          type: "table",
          name: "investor_details",
          id: "investor_details",
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "Name",
                hi: "नाम",
              },
              width: "15%",
              name: "name",
              validation: {
                required: true,
                message: {
                  en: "Name is required.",
                  hi: "नाम आवश्यक है।",
                },
              },
            },
            {
              label: {
                en: "Designation",
                hi: "पदनाम",
              },
              width: "10%",
              name: "designation",
              validation: {
                required: true,
                message: {
                  en: "Designation is required.",
                  hi: "पदनाम आवश्यक है।",
                },
              },
            },
            {
              label: {
                en: "Gender",
                hi: "लिंग",
              },
              width: "10%",
              name: "gender",
              type: "select",
              options: [
                {
                  label: "Male",
                  hi: "पुरुष",
                  value: "Male",
                },
                {
                  label: "Female",
                  hi: "महिला",
                  value: "Female",
                },
                {
                  label: "Other",
                  hi: "अन्य",
                  value: "Other",
                },
              ],
              validation: {
                required: true,
                message: {
                  en: "Gender is required.",
                  hi: "लिंग आवश्यक है।",
                },
              },
            },
            {
              label: {
                en: "Share Holding (%)",
                hi: "शेयर होल्डिंग (%)",
              },
              width: "10%",
              name: "share_holding",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid percentage.",
                  hi: "मान्य प्रतिशत दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Mobile Number",
                hi: "मोबाइल नंबर",
              },
              width: "10%",
              name: "mobile_number",
              maxLength: 10,
              validation: {
                required: true,
                pattern: /^[6-9]\d{9}$/,
                message: {
                  en: "Enter a valid 10-digit mobile number.",
                  hi: "मान्य 10 अंकों का मोबाइल नंबर दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "PAN Number",
                hi: "पैन नंबर",
              },
              width: "10%",
              name: "pan_number",
              maxLength: 10,
              validation: {
                required: true,
                pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: {
                  en: "Enter a valid PAN number.",
                  hi: "मान्य पैन नंबर दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Uttarakhand Resident",
                hi: "उत्तराखंड निवासी",
              },
              width: "7%",
              name: "uttarakhandi_resident",
              maxLength: 3,
              validation: {
                required: true,
                pattern: /^yes$/i,
                message: {
                  en: "Only 'Yes' is allowed.",
                  hi: "केवल 'हाँ' स्वीकार्य है।",
                },
              },
            },
            {
              label: {
                en: "UK Permanent Resident Certificate",
                hi: "उत्तराखंड स्थायी निवासी प्रमाण पत्र",
              },
              width: "15%",
              name: "uttarakhandi_resident_document",
              type: "file",
              accept: ".pdf,.png,.jpg,.jpeg",
              validation: {
                required: true,
                message: {
                  en: "Please upload a valid file (PDF, JPG, or PNG).",
                  hi: "कृपया मान्य दस्तावेज़ अपलोड करें (PDF, JPG या PNG)।",
                },
              },
            },
          ],
          rows: [
            {
              name: "",
              designation: "",
              gender: "",
              share_holding: "",
              mobile_number: "",
              pan_number: "",
              uttarakhandi_resident: "",
              uttarakhandi_resident_document: "",
            },
          ],
        },
      },
    ],
  },
  {
    title: { en: "Uttarakhand Bonafide Resident,Uttarakhand Non Bonafide Resident", hi: "उत्तराखंड बोनाफाइड निवासी, उत्तराखंड गैर-बोनाफाइड निवासी" },
    fields: [
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Male",
          hi: "पुरुष",
        },
        htmlFor: "male_bonafied",
        inputProps: {
          id: "male_bonafied",
          name: "male_bonafied",
          type: "text",
          placeholder: {
            en: "Male",
            hi: "पुरुष",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid numeric value",
              hi: "कृपया केवल संख्या दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Female",
          hi: "महिला",
        },
        htmlFor: "female_bonafied",
        inputProps: {
          id: "female_bonafied",
          name: "female_bonafied",
          type: "text",
          placeholder: {
            en: "Female",
            hi: "महिला",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid numeric value",
              hi: "कृपया केवल संख्या दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Others",
          hi: "अन्य",
        },
        htmlFor: "others_bonafied",
        inputProps: {
          id: "others_bonafied",
          name: "others_bonafied",
          type: "text",
          placeholder: {
            en: "Others",
            hi: "अन्य",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid numeric value",
              hi: "कृपया केवल संख्या दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Male",
          hi: "पुरुष",
        },
        htmlFor: "male_non_bonafied",
        inputProps: {
          id: "male_non_bonafied",
          name: "male_non_bonafied",
          type: "text",
          placeholder: {
            en: "Male",
            hi: "पुरुष",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid numeric value",
              hi: "कृपया केवल संख्या दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Female",
          hi: "महिला",
        },
        htmlFor: "female_non_bonafied",
        inputProps: {
          id: "female_non_bonafied",
          name: "female_non_bonafied",
          type: "text",
          placeholder: {
            en: "Female",
            hi: "महिला",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid numeric value",
              hi: "कृपया केवल संख्या दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Others",
          hi: "अन्य",
        },
        htmlFor: "others_non_bonafied",
        inputProps: {
          id: "others_non_bonafied",
          name: "others_non_bonafied",
          type: "text",
          placeholder: {
            en: "Others",
            hi: "अन्य",
          },
          disabled: false,
          validation: {
            required: true,
            pattern: /^\d+$/,
            message: {
              en: "Enter a valid numeric value",
              hi: "कृपया केवल संख्या दर्ज करें",
            },
          },
        },
      },

    ],
  },
  {
    title: { en: "Total Employment", hi: "कुल रोजगार" },
    fields: [
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Male",
          hi: "पुरुष",
        },
        htmlFor: "male_total",
        inputProps: {
          id: "male_total",
          name: "male_total",
          type: "text",
          placeholder: {
            en: "Male",
            hi: "पुरुष",
          },
          disabled: true,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Female",
          hi: "महिला",
        },
        htmlFor: "female_total",
        inputProps: {
          id: "female_total",
          name: "female_total",
          type: "text",
          placeholder: {
            en: "Female",
            hi: "महिला",
          },
          disabled: true,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Others",
          hi: "अन्य",
        },
        htmlFor: "others_total",
        inputProps: {
          id: "others_total",
          name: "others_total",
          type: "text",
          placeholder: {
            en: "Others",
            hi: "अन्य",
          },
          disabled: true,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/6 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total",
          hi: "कुल",
        },
        htmlFor: "total_permanent_employees",
        inputProps: {
          id: "total_permanent_employees",
          name: "total_permanent_employees",
          type: "text",
          placeholder: {
            en: "Total",
            hi: "कुल",
          },
          disabled: true,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "% of Bonafide Employees",
          hi: "वास्तविक कर्मचारियों का प्रतिशत",
        },
        htmlFor: "bonafied_employees_percentage",
        inputProps: {
          id: "bonafied_employees_percentage",
          name: "bonafied_employees_percentage",
          type: "text",
          placeholder: {
            en: "% of Bonafide Employees",
            hi: "वास्तविक कर्मचारियों का प्रतिशत",
          },
          disabled: true,
          validation: {},
        },
      },
    ],
  },
];

export const incentiveClaimSection2 = [
  {
    title: { en: "Project Details", hi: "परियोजना विवरण" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Project Type", hi: "परियोजना का प्रकार" },
        htmlFor: "project_type",
        inputProps: {
          id: "project_type",
          name: "project_type",
          type: "select",
          placeholder: { en: "Select", hi: "चयन करें" },
          options: [
            { label: "New", value: "New", hi: "नया" },
            { label: "Expansion", value: "Expansion", hi: "विस्तार" },
          ],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select a project type.",
              hi: "कृपया परियोजना का प्रकार चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Area Category", hi: "क्षेत्र श्रेणी" },
        htmlFor: "area_category",
        inputProps: {
          id: "area_category",
          name: "area_category",
          type: "select",
          placeholder: { en: "Select", hi: "चयन करें" },
          options: [
            { label: "A", value: "A", hi: "ए" },
            { label: "B", value: "B", hi: "बी" },
            { label: "C", value: "C", hi: "सी" },
          ],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select area category.",
              hi: "कृपया क्षेत्र श्रेणी चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Date of Commercial Operation",
          hi: "व्यावसायिक संचालन की तिथि",
        },
        htmlFor: "commercial_operation_date",
        inputProps: {
          id: "commercial_operation_date",
          name: "commercial_operation_date",
          type: "date",
          placeholder: {
            en: "Commercial Operation Date",
            hi: "संचालन की तिथि",
          },
          disabled: false,
          required: true,
          max: getLocalDate(),
          validation: {
            required: true,
            message: {
              en: "Commercial operation date is required.",
              hi: "व्यावसायिक संचालन की तिथि आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Project Category", hi: "परियोजना श्रेणी" },
        htmlFor: "project_category",
        inputProps: {
          id: "project_category",
          name: "project_category",
          type: "select",
          placeholder: { en: "Select", hi: "चयन करें" },
          options: [
            { label: "Hospitality", hi: "आतिथ्य", value: "Hospitality" },
          ],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select a project category.",
              hi: "कृपया परियोजना श्रेणी चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "NIC Code", hi: "एनआईसी कोड" },
        htmlFor: "nic_code",
        inputProps: {
          id: "nic_code",
          name: "nic_code",
          type: "select",
          placeholder: { en: "Select NIC Code", hi: "एनआईसी कोड चुनें" },
          options: allNicOptions, // already handled elsewhere
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select a NIC Code.",
              hi: "कृपया एनआईसी कोड चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: {
          en: "Name of Tourism Product",
          hi: "पर्यटन उत्पाद का नाम",
        },
        htmlFor: "tourism_product_name",
        inputProps: {
          id: "tourism_product_name",
          name: "tourism_product_name",
          type: "select",
          placeholder: { en: "Select", hi: "चयन करें" },
          options: [],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select a tourism product.",
              hi: "कृपया पर्यटन उत्पाद चुनें।",
            },
          },
        },
      },
    ],
  },
  {
    title: { en: "Land Details", hi: "भूमि विवरण" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Land Type",
          hi: "भूमि का प्रकार",
        },
        htmlFor: "land_type",
        inputProps: {
          id: "land_type",
          name: "land_type",
          type: "select",
          placeholder: {
            en: "Select Land Type",
            hi: "भूमि का प्रकार चुनें",
          },
          options: [
            { label: "Own Land", hi: "स्वयं की भूमि", value: "Own Land" },
            { label: "Purchased Land", hi: "खरीदी गई भूमि", value: "Purchased Land" },
            { label: "Lease/Rental Land", hi: "लीज / किराये की भूमि", value: "Lease/Rental Land" },
            { label: "Government Allotted", hi: "सरकारी आवंटित", value: "Government Allotted" },
          ],
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please select land type.",
              hi: "कृपया भूमि का प्रकार चुनें।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "District",
          hi: "जिला",
        },
        htmlFor: "land_district",
        inputProps: {
          id: "land_district",
          name: "land_district",
          type: "select",
          placeholder: {
            en: "Select District",
            hi: "जिला चुनें",
          },
          options: uttarakhandDistrictList,
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "District is required.",
              hi: "जिला आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Land Tehsil",
          hi: "तहसील",
        },
        htmlFor: "land_tehsil",
        inputProps: {
          id: "land_tehsil",
          name: "land_tehsil",
          type: "select",
          placeholder: {
            en: "Select Tehsil",
            hi: "तहसील चुनें",
          },
          options: [],
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Land Tehsil is required.",
              hi: "तहसील आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Land Village",
          hi: "गांव",
        },
        htmlFor: "land_village",
        inputProps: {
          id: "land_village",
          name: "land_village",
          type: "text",
          placeholder: {
            en: "Enter Land Village",
            hi: "गांव का नाम दर्ज करें",
          },
          required: true,
          validation: {
            required: true,
            message: {
              en: "Land Village is required.",
              hi: "गांव का नाम आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Land Mauja",
          hi: "मौजा",
        },
        htmlFor: "mauja",
        inputProps: {
          id: "mauja",
          name: "mauja",
          type: "text",
          placeholder: {
            en: "Enter Mauja",
            hi: "मौजा दर्ज करें",
          },
          required: true,
          validation: {
            required: true,
            message: {
              en: "Mauja is required.",
              hi: "मौजा आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Registration Date",
          hi: "पंजीकरण तिथि",
        },
        htmlFor: "registeration_allotment_date",
        inputProps: {
          id: "registeration_allotment_date",
          name: "registeration_allotment_date",
          type: "date",
          placeholder: {
            en: "Registration / Allotment Date",
            hi: "पंजीकरण / आवंटन तिथि",
          },
          disabled: false,
          max: getLocalDate(),
          required: true,
          validation: {
            required: true,
            message: {
              en: "Registration / Allotment Date is required.",
              hi: "पंजीकरण / आवंटन तिथि आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Name of Original Lessee",
          hi: "मूल पट्टाधारी का नाम",
        },
        htmlFor: "original_lessee_department_name",
        inputProps: {
          id: "original_lessee_department_name",
          name: "original_lessee_department_name",
          type: "text",
          placeholder: {
            en: "Enter Name of Original Lessee",
            hi: "मूल पट्टाधारी का नाम दर्ज करें",
          },
          required: true,
          validation: {
            required: true,
            message: {
              en: "Name of Original Lessee is required.",
              hi: "मूल पट्टाधारी का नाम आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Date of Allotment / Agreement",
          hi: "आवंटन / अनुबंध की तिथि",
        },
        htmlFor: "date_of_allotment_agreement",
        inputProps: {
          id: "date_of_allotment_agreement",
          name: "date_of_allotment_agreement",
          type: "date",
          placeholder: {
            en: "Allotment / Agreement Date",
            hi: "आवंटन / अनुबंध तिथि",
          },
          max: getLocalDate(),
          required: true,
          disabled: false,
          validation: {
            required: true,
            message: {
              en: "Allotment / Agreement date is required.",
              hi: "आवंटन / अनुबंध तिथि आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "No of Years",
          hi: "वर्षों की संख्या",
        },
        htmlFor: "no_of_years",
        inputProps: {
          id: "no_of_years",
          name: "no_of_years",
          type: "text",
          placeholder: {
            en: "Enter No of Years",
            hi: "वर्षों की संख्या दर्ज करें",
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^[0-9]{1,2}$/,
            message: {
              en: "Please enter a valid number of years (1–99).",
              hi: "कृपया वर्षों की वैध संख्या दर्ज करें (1–99)।",
            },
          },
        },
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: "",
        htmlFor: "kharsa_raqwa_number",
        inputProps: {
          type: "table",
          name: "kharsa_raqwa_number",
          id: "kharsa_raqwa_number",
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2  text-gray-700",
          headers: [
            {
              label: {
                en: "Khasra No.",
                hi: "खसरा संख्या",
              },
              name: "khasra_no",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9\/-]+$/,
                message: {
                  en: "Enter a valid Khasra No.",
                  hi: "मान्य खसरा संख्या दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Raqwa (in hectares)",
                hi: "रकबा (हेक्टेयर में)",
              },
              name: "raqwa_in_hectares",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,4})?$/,
                message: {
                  en: "Enter a valid Raqwa.",
                  hi: "मान्य रकबा दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Area in SQM",
                hi: "क्षेत्रफल (वर्ग मीटर)",
              },
              name: "area_in_sqm",
              disabled: true,
              validation: {
                required: true,
                message: {
                  en: "Area in SQM is required.",
                  hi: "क्षेत्रफल (वर्ग मीटर) आवश्यक है।",
                },
              },
            },
          ],
          rows: [
            {
              khasra_no: "",
              raqwa_in_hectares: "",
              area_in_sqm: "",
            },
          ],
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Land (In SQM)",
          hi: "कुल भूमि (वर्ग मीटर में)",
        },
        htmlFor: "total_land_in_sqm",
        inputProps: {
          id: "total_land_in_sqm",
          name: "total_land_in_sqm",
          type: "text",
          placeholder: {
            en: "Total Land (In SQM)",
            hi: "कुल भूमि (वर्ग मीटर)",
          },
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Total Land (In SQM) is required.",
              hi: "कुल भूमि (वर्ग मीटर) आवश्यक है।",
            },
          },
        },
      },
    ],
  },
];

export const incentiveClaimSection3 = [
  {
    title: sourceofFinanceTitle,
    fields: [
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Term Loan",
          hi: "टर्म लोन",
        },
        htmlFor: "term_loan",
        inputProps: {
          id: "term_loan",
          name: "term_loan",
          type: "checkbox",
          placeholder: "",
          disabled: false,
          required: false,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Promoters Contribution",
          hi: "प्रवर्तक का अंशदान",
        },
        htmlFor: "promoter_contribution_equity",
        inputProps: {
          id: "promoter_contribution_equity",
          name: "promoter_contribution_equity",
          type: "checkbox",
          placeholder: "",
          disabled: false,
          required: false,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Unsecured Loan",
          hi: "असुरक्षित ऋण",
        },
        htmlFor: "unsecured_loan",
        inputProps: {
          id: "unsecured_loan",
          name: "unsecured_loan",
          type: "checkbox",
          placeholder: "",
          disabled: false,
          required: false,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Any Other Source",
          hi: "कोई अन्य स्रोत",
        },
        htmlFor: "other_source",
        inputProps: {
          id: "other_source",
          name: "other_source",
          type: "checkbox",
          placeholder: "",
          disabled: false,
          required: false,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Term Loan (In INR)",
          hi: "टर्म लोन (रुपये में)",
        },
        htmlFor: "term_loan_amount",
        inputProps: {
          id: "term_loan_amount",
          name: "term_loan_amount",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Term Loan amount is required.",
              hi: "टर्म लोन की राशि आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Promoters Contribution (In INR)",
          hi: "प्रवर्तक का अंशदान (रुपये में)",
        },
        htmlFor: "promoter_contribution_amount",
        inputProps: {
          id: "promoter_contribution_amount",
          name: "promoter_contribution_amount",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Promoters contribution amount is required.",
              hi: "प्रवर्तक के अंशदान की राशि आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Unsecured Loan (In INR)",
          hi: "असुरक्षित ऋण (रुपये में)",
        },
        htmlFor: "unsecured_loan_amount",
        inputProps: {
          id: "unsecured_loan_amount",
          name: "unsecured_loan_amount",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Unsecured loan amount is required.",
              hi: "असुरक्षित ऋण की राशि आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Please Specify",
          hi: "कृपया विवरण दें",
        },
        htmlFor: "please_specify",
        inputProps: {
          id: "please_specify",
          name: "please_specify",
          type: "text",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Please specify details.",
              hi: "कृपया विवरण प्रदान करें।",
            },
          },
        },
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Term Loan Details (if any):",
          hi: "टर्म लोन विवरण (यदि कोई हो):",
        },
        htmlFor: "term_loan_details",
        inputProps: {
          type: "table",
          name: "term_loan_details",
          id: "term_loan_details",
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "Bank Name",
                hi: "बैंक का नाम",
              },
              width: "15%",
              name: "bank_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9\s\u0900-\u097F]+$/,
                message: {
                  en: "Bank Name is required (letters/numbers allowed).",
                  hi: "बैंक का नाम आवश्यक है (केवल अक्षर और अंक)।",
                },
              },
            },
            {
              label: {
                en: "Branch Name",
                hi: "शाखा का नाम",
              },
              width: "12%",
              name: "branch_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9\s\u0900-\u097F]+$/,
                message: {
                  en: "Branch Name is required (letters/numbers allowed).",
                  hi: "शाखा का नाम आवश्यक है (केवल अक्षर और अंक)।",
                },
              },
            },
            {
              label: {
                en: "IFSC Code",
                hi: "आईएफएससी कोड",
              },
              width: "12%",
              name: "ifsc_code",
              validation: {
                required: true,
                pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                message: {
                  en: "Enter a valid IFSC code (e.g., SBIN0001234).",
                  hi: "मान्य IFSC कोड दर्ज करें (जैसे SBIN0001234)।",
                },
              },
            },
            {
              label: {
                en: "Loan Account Number",
                hi: "ऋण खाता संख्या",
              },
              width: "15%",
              name: "loan_account_number",
              validation: {
                required: true,
                pattern: /^\d{6,18}$/,
                message: {
                  en: "Enter a valid Loan Account Number (6–18 digits).",
                  hi: "मान्य ऋण खाता संख्या दर्ज करें (6–18 अंक)।",
                },
              },
            },
            {
              label: {
                en: "Sanctioned Loan Amount (In INR)",
                hi: "स्वीकृत ऋण राशि (रुपये में)",
              },
              width: "15%",
              name: "sanctioned_loan_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid sanctioned amount (up to 2 decimals).",
                  hi: "मान्य स्वीकृत राशि दर्ज करें (2 दशमलव तक)।",
                },
              },
            },
            {
              label: {
                en: "Sanction Date",
                hi: "स्वीकृति तिथि",
              },
              width: "15%",
              name: "sanction_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Sanction Date is required.",
                  hi: "स्वीकृति तिथि आवश्यक है।",
                },
              },
            },
            {
              label: {
                en: "First Instalment Disbursal Date",
                hi: "पहली किस्त जारी करने की तिथि",
              },
              width: "15%",
              name: "first_instalment_disbursal_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "First instalment disbursal date is required.",
                  hi: "पहली किस्त जारी करने की तिथि आवश्यक है।",
                },
              },
            },
            {
              label: {
                en: "Total Loan Disbursed Amount (In INR)",
                hi: "कुल वितरित ऋण राशि (रुपये में)",
              },
              width: "15%",
              name: "total_loan_disbursed_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid disbursed amount (up to 2 decimals).",
                  hi: "मान्य वितरित राशि दर्ज करें (2 दशमलव तक)।",
                },
              },
            },
          ],
          rows: [
            {
              bank_name: "",
              branch_name: "",
              loan_account_number: "",
              sanctioned_loan_amount: "",
              sanction_date: "",
              first_instalment_disbursal_date: "",
              total_loan_disbursed_amount: "",
            },
          ],
        },
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Details of Promoter's Contribution (EQUITY) (if any):",
          hi: "प्रवर्तक के अंशदान (इक्विटी) का विवरण (यदि कोई हो):",
        },
        htmlFor: "promoters_contribution_details",
        inputProps: {
          type: "table",
          name: "promoters_contribution_details",
          id: "promoters_contribution_details",
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "Name of the Promoter",
                hi: "प्रवर्तक का नाम",
              },
              width: "25%",
              name: "name_of_the_promoter",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]+$/,
                message: {
                  en: "Enter a valid promoter name.",
                  hi: "मान्य प्रवर्तक का नाम दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Amount (In INR)",
                hi: "राशि (रुपये में)",
              },
              width: "20%",
              name: "amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid amount (e.g., 1000 or 1000.50).",
                  hi: "मान्य राशि दर्ज करें (जैसे 1000 या 1000.50)।",
                },
              },
            },
            {
              label: {
                en: "PAN Number",
                hi: "पैन संख्या",
              },
              width: "20%",
              name: "pan_number",
              maxLength: 10,
              validation: {
                required: true,
                pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: {
                  en: "Enter a valid PAN (e.g., ABCDE1234F).",
                  hi: "मान्य पैन संख्या दर्ज करें (जैसे ABCDE1234F)।",
                },
              },
            },
            {
              label: {
                en: "Mode of Payment",
                hi: "भुगतान का माध्यम",
              },
              width: "20%",
              name: "mode_of_payment",
              type: "select",
              options: [
                {
                  value: "Bank Payment",
                  label: "Bank Payment", hi: "बैंक भुगतान",
                },
                {
                  value: "Cash Payment",
                  label: "Cash Payment", hi: "नकद भुगतान",
                },
              ],
              validation: {
                required: true,
                message: {
                  en: "Mode of Payment is required.",
                  hi: "भुगतान का माध्यम आवश्यक है।",
                },
              },
            },
          ],
          rows: [
            {
              name_of_the_promoter: "",
              amount: "",
              pan_number: "",
              mode_of_payment: "",
            },
          ],
        },
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Details of Unsecured Loan (if any):",
          hi: "असुरक्षित ऋण का विवरण (यदि कोई हो):",
        },
        htmlFor: "unsecured_loan_details",
        inputProps: {
          type: "table",
          name: "unsecured_loan_details",
          id: "unsecured_loan_details",
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "Name of the Promoter",
                hi: "प्रवर्तक का नाम",
              },
              width: "25%",
              name: "name_of_the_promoter",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]+$/,
                message: {
                  en: "Enter a valid promoter name.",
                  hi: "मान्य प्रवर्तक का नाम दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Amount (In INR)",
                hi: "राशि (रुपये में)",
              },
              width: "20%",
              name: "amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid amount (e.g., 1000 or 1000.50).",
                  hi: "मान्य राशि दर्ज करें (जैसे 1000 या 1000.50)।",
                },
              },
            },
            {
              label: {
                en: "PAN Number",
                hi: "पैन संख्या",
              },
              width: "20%",
              name: "pan_number",
              maxLength: 10,
              validation: {
                required: true,
                pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: {
                  en: "Enter a valid PAN (e.g., ABCDE1234F).",
                  hi: "मान्य पैन संख्या दर्ज करें (जैसे ABCDE1234F)।",
                },
              },
            },
            {
              label: {
                en: "Mode of Payment",
                hi: "भुगतान का माध्यम",
              },
              width: "20%",
              name: "mode_of_payment",
              type: "select",
              options: [
                {
                  value: "Bank Payment",
                  label: "Bank Payment", hi: "बैंक भुगतान",
                },
                {
                  value: "Cash Payment",
                  label: "Cash Payment", hi: "नकद भुगतान",
                },
              ],
              validation: {
                required: true,
                message: {
                  en: "Mode of Payment is required.",
                  hi: "भुगतान का माध्यम आवश्यक है।",
                },
              },
            },
          ],
          rows: [
            {
              name_of_the_promoter: "",
              amount: "",
              pan_number: "",
              mode_of_payment: "",
            },
          ],
        },
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Bank Details used for project",
          hi: "परियोजना के लिए उपयोग किए गए बैंक विवरण",
        },
        htmlFor: "bank_details_used_for_project",
        inputProps: {
          type: "table",
          name: "bank_details_used_for_project",
          id: "bank_details_used_for_project",
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "Name Of Bank",
                hi: "बैंक का नाम",
              },
              width: "15%",
              name: "name_of_bank",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid bank name (only letters).",
                  hi: "कृपया वैध बैंक नाम दर्ज करें (केवल अक्षर)।",
                },
              },
            },
            {
              label: {
                en: "Branch Name",
                hi: "शाखा का नाम",
              },
              width: "15%",
              name: "branch_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9\s.-]{2,100}$/,
                message: {
                  en: "Enter a valid branch name.",
                  hi: "कृपया वैध शाखा नाम दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "Account Holder Name",
                hi: "खाता धारक का नाम",
              },
              width: "15%",
              name: "account_holder_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid account holder name.",
                  hi: "कृपया वैध खाता धारक का नाम दर्ज करें।",
                },
              },
            },
            {
              label: {
                en: "IFSC Code",
                hi: "आईएफएससी कोड",
              },
              width: "15%",
              name: "ifsc_code",
              maxLength: 11,
              validation: {
                required: true,
                pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                message: {
                  en: "Enter a valid IFSC code (e.g., SBIN0001234).",
                  hi: "कृपया वैध IFSC कोड दर्ज करें (उदा. SBIN0001234)।",
                },
              },
            },
            {
              label: {
                en: "Bank Account Number",
                hi: "बैंक खाता संख्या",
              },
              width: "15%",
              name: "bank_account_number",
              validation: {
                required: true,
                pattern: /^[0-9]{9,18}$/,
                message: {
                  en: "Enter a valid bank account number (9–18 digits).",
                  hi: "कृपया वैध बैंक खाता संख्या दर्ज करें (9–18 अंक)।",
                },
              },
            },
            {
              label: {
                en: "Bank Account Type",
                hi: "बैंक खाता प्रकार",
              },
              width: "15%",
              name: "bank_account_type",
              type: "select",
              options: [
                {
                  value: "Current",
                  label: "Current", hi: "चालू खाता",
                },
                {
                  value: "Savings",
                  label: "Savings", hi: "बचत खाता",
                },
                {
                  value: "Term Loan",
                  label: "Term Loan", hi: "टर्म लोन",
                },
              ],
              validation: {
                required: true,
                message: {
                  en: "Bank Account Type is required.",
                  hi: "बैंक खाता प्रकार आवश्यक है।",
                },
              },
            },
          ],
          rows: [
            {
              name_of_bank: "",
              branch_name: "",
              account_holder_name: "",
              ifsc_code: "",
              bank_account_number: "",
              bank_account_type: "",
            },
          ],
        },
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Authorized Person",
          hi: "अधिकृत व्यक्ति",
        },
        htmlFor: "authorized_person",
        inputProps: {
          type: "table",
          name: "authorized_person",
          id: "authorized_person",
          canAddMore: false,
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "Name",
                hi: "नाम",
              },
              width: "15%",
              name: "name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid name (letters only).",
                  hi: "कृपया वैध नाम दर्ज करें (केवल अक्षर)।",
                },
              },
            },
            {
              label: {
                en: "Email Address",
                hi: "ईमेल पता",
              },
              width: "25%",
              name: "email_address",
              validation: {
                required: true,
                pattern:
                  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                message: {
                  en: "Enter a valid email address (e.g., name@example.com).",
                  hi: "कृपया वैध ईमेल पता दर्ज करें (उदा. name@example.com)।",
                },
              },
            },
            {
              label: {
                en: "Mobile Number",
                hi: "मोबाइल नंबर",
              },
              width: "20%",
              name: "mobile_number",
              maxLength: 10,
              validation: {
                required: true,
                pattern: /^[6-9]\d{9}$/,
                message: {
                  en: "Enter a valid 10-digit mobile number.",
                  hi: "कृपया वैध 10 अंकों का मोबाइल नंबर दर्ज करें।",
                },
              },
            },
          ],
          rows: [
            {
              name: "",
              email_address: "",
              mobile_number: "",
            },
          ],
        },
      }
    ],
  },
];

export const incentiveClaimSection4 = [
  {
    title:
      { en: "Minimum Infra/Min infra /Amenities/Specific Conditions as per Policy Guidelines", hi: "न्यूनतम इन्फ्रास्ट्रक्चर/सुविधाएं/नीति दिशानिर्देशों के अनुसार विशिष्ट शर्तें" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Major Component Of Infrastructure", hi: "इन्फ्रास्ट्रक्चर का मुख्य घटक" },
        htmlFor: "major_component_of_infrastructure",
        inputProps: {
          id: "major_component_of_infrastructure",
          name: "major_component_of_infrastructure",
          type: "text",
          placeholder: { en: "Add Component", hi: "घटक जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^[A-Za-z0-9\s\u0900-\u097F]+$/,
            message: {
              en: "Please enter a valid component (letters and numbers only).",
              hi: "कृपया मान्य घटक दर्ज करें (अक्षर और संख्या)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Total Area in Square Meter", hi: "कुल क्षेत्रफल (वर्ग मीटर में)" },
        htmlFor: "total_area_sqm",
        inputProps: {
          id: "total_area_sqm",
          name: "total_area_sqm",
          type: "text",
          placeholder: { en: "Add Area", hi: "क्षेत्र जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?\s*[A-Za-z\u0900-\u097F\s]*$/,
            message: {
              en: "Enter area (number up to 2 decimals, e.g., 1000 sqm).",
              hi: "क्षेत्रफल दर्ज करें (2 दशमलव तक, उदाहरण: 1000 वर्ग मीटर)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Built Up Area", hi: "निर्मित क्षेत्र" },
        htmlFor: "build_up_area",
        inputProps: {
          id: "build_up_area",
          name: "build_up_area",
          type: "text",
          placeholder: { en: "Add Area", hi: "क्षेत्र जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?\s*[A-Za-z\u0900-\u097F\s]*$/,
            message: {
              en: "Enter built-up area (e.g., 500.5 sqm).",
              hi: "निर्मित क्षेत्र दर्ज करें (उदा. 500.5 वर्ग मीटर)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "No. of Rooms/Cottages/Villas", hi: "कमरे/कॉटेज/विला की संख्या" },
        htmlFor: "number_of_rooms",
        inputProps: {
          id: "number_of_rooms",
          name: "number_of_rooms",
          type: "text",
          placeholder: { en: "Enter number", hi: "संख्या दर्ज करें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+$/,
            message: {
              en: "Enter a whole number (e.g., 10).",
              hi: "कृपया पूर्ण संख्या दर्ज करें (उदा. 10)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: { en: "No. of Parking Space (ECS) and Area", hi: "पार्किंग स्पेस/क्षेत्र (ECS)" },
        htmlFor: "parking_area",
        inputProps: {
          id: "parking_area",
          name: "parking_area",
          type: "text",
          placeholder: { en: "Enter Number Area", hi: "संख्या/क्षेत्र दर्ज करें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?\s*[A-Za-z\u0900-\u097F\s]*$/,
            message: {
              en: "Enter parking space (e.g., 10) or area (e.g., 200 sqm).",
              hi: "पार्किंग स्पेस/क्षेत्र दर्ज करें (उदा. 10 या 200 वर्ग मीटर)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: { en: "Restaurants Area and Capacity", hi: "रेस्टोरेंट क्षेत्र और क्षमता" },
        htmlFor: "resuarant_area",
        inputProps: {
          id: "resuarant_area",
          name: "resuarant_area",
          type: "text",
          placeholder: { en: "Add Area Capacity", hi: "क्षेत्र/क्षमता जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?\s*[A-Za-z\u0900-\u097F\s]*$/,
            message: {
              en: "Enter restaurant area/capacity (e.g., 250 sqm).",
              hi: "रेस्टोरेंट क्षेत्र/क्षमता दर्ज करें (उदा. 250 वर्ग मीटर)।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Facilities Developed in MICE/Convention center", hi: "MICE/कॉन्फ्रेंस सेंटर में विकसित सुविधाएँ" },
        htmlFor: "mice_Facilities",
        inputProps: {
          id: "mice_Facilities",
          name: "mice_Facilities",
          type: "text",
          placeholder: { en: "Add Center", hi: "सेंटर जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^[^<>]+$/,
            message: {
              en: "Enter valid value",
              hi: "कृपया मान्य मान दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Tourist Village/Resort Activities", hi: "टूरिस्ट विलेज/रिसॉर्ट गतिविधियाँ" },
        htmlFor: "tourist_resort_activities",
        inputProps: {
          id: "tourist_resort_activities",
          name: "tourist_resort_activities",
          type: "text",
          placeholder: { en: "Add Activities", hi: "गतिविधियाँ जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^[^<>]+$/,
            message: {
              en: "Enter valid value",
              hi: "कृपया मान्य मान दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Restaurant/Local Cuisine/Way Side Amenities", hi: "रेस्टोरेंट/स्थानीय व्यंजन/वे साइड सुविधाएँ" },
        htmlFor: "resuarant_side_amenities",
        inputProps: {
          id: "resuarant_side_amenities",
          name: "resuarant_side_amenities",
          type: "text",
          placeholder: { en: "Add Amenities", hi: "सुविधाएँ जोड़ें" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^[^<>]+$/,
            message: {
              en: "Enter valid value",
              hi: "कृपया मान्य मान दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Developed Facilities in Amusement park", hi: "मनोरंजन पार्क में विकसित सुविधाएँ" },
        htmlFor: "developed_facilities_amusement",
        inputProps: {
          id: "developed_facilities_amusement",
          name: "developed_facilities_amusement",
          type: "text",
          placeholder: { en: "", hi: "" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^[^<>]+$/,
            message: {
              en: "Enter valid value",
              hi: "कृपया मान्य मान दर्ज करें",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 px-2 mb-4",
        label: { en: "Any Other", hi: "अन्य" },
        htmlFor: "any_other_amenities",
        inputProps: {
          id: "any_other_amenities",
          name: "any_other_amenities",
          type: "text",
          placeholder: { en: "Other", hi: "अन्य" },
          disabled: false,
          required: false,
          validation: {
            pattern: /^[^<>]+$/,
            message: {
              en: "Enter valid value",
              hi: "कृपया मान्य मान दर्ज करें",
            },
          },
        },
      },
    ],
  },
  {
    title: { en: "Electricity", hi: "बिजली" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Approved Load (kW)",
          hi: "अनुमोदित लोड (किलोवाट)"
        },
        htmlFor: "electricity_approved_load",
        inputProps: {
          id: "electricity_approved_load",
          name: "electricity_approved_load",
          type: "text",
          placeholder: {
            en: "Enter Approved Load",
            hi: "अनुमोदित लोड दर्ज करें"
          },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter approved load as a number (up to 2 decimals).",
              hi: "कृपया अनुमोदित लोड संख्या (अधिकतम 2 दशमलव) में दर्ज करें।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Connected Load (kW)",
          hi: "कनेक्टेड लोड (किलोवाट)"
        },
        htmlFor: "electricity_connected_load",
        inputProps: {
          id: "electricity_connected_load",
          name: "electricity_connected_load",
          type: "text",
          placeholder: {
            en: "Enter Connected Load",
            hi: "कनेक्टेड लोड दर्ज करें"
          },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter connected load as a number (up to 2 decimals).",
              hi: "कृपया कनेक्टेड लोड संख्या (अधिकतम 2 दशमलव) में दर्ज करें।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Capacity of Internal Power Plant (kW)",
          hi: "आंतरिक पावर प्लांट क्षमता (किलोवाट)"
        },
        htmlFor: "power_plant_capacity",
        inputProps: {
          id: "power_plant_capacity",
          name: "power_plant_capacity",
          type: "text",
          placeholder: {
            en: "Enter Capacity",
            hi: "क्षमता दर्ज करें"
          },
          disabled: false,
          required: false,
          validation: {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter power plant capacity as a number (up to 2 decimals).",
              hi: "कृपया पावर प्लांट क्षमता संख्या (अधिकतम 2 दशमलव) में दर्ज करें।"
            },
          },
        },
      },
    ],
  },
];

export const incentiveClaimSection5 = [
  {
    title: { en: "Documents", hi: "दस्तावेज़" },
    fields: [
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Investment Certificate",
          hi: "निवेश प्रमाणपत्र"
        },
        htmlFor: "investment_certificate",
        inputProps: {
          id: "investment_certificate",
          name: "investment_certificate",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: true,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "First Invoice Copy",
          hi: "पहली चालान की प्रति"
        },
        htmlFor: "first_invoice_copy",
        inputProps: {
          id: "first_invoice_copy",
          name: "first_invoice_copy",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "First Invoice Copy is required.",
              hi: "पहली चालान की प्रति आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Travel Trade Registration Document (COD)",
          hi: "ट्रैवल ट्रेड पंजीकरण दस्तावेज़ (COD)"
        },
        htmlFor: "travel_trade_registration_document_cod",
        inputProps: {
          id: "travel_trade_registration_document_cod",
          name: "travel_trade_registration_document_cod",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Travel Trade Registration Document (COD) is required.",
              hi: "ट्रैवल ट्रेड पंजीकरण दस्तावेज़ (COD) आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Letter of legal authorized person",
          hi: "कानूनी अधिकृत व्यक्ति का पत्र"
        },
        htmlFor: "letter_of_legal_authorized_person",
        inputProps: {
          id: "letter_of_legal_authorized_person",
          name: "letter_of_legal_authorized_person",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Letter of legal authorized person is required.",
              hi: "कानूनी अधिकृत व्यक्ति का पत्र आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Proof of land ownership / land allotment certificate",
          hi: "भूमि स्वामित्व / भूमि आबंटन प्रमाणपत्र"
        },
        htmlFor: "proof_of_land_ownership",
        inputProps: {
          id: "proof_of_land_ownership",
          name: "proof_of_land_ownership",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Proof of land ownership / land allotment certificate is required.",
              hi: "भूमि स्वामित्व / भूमि आबंटन प्रमाणपत्र आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Approved Building Plan and permissions granted",
          hi: "अनुमोदित भवन योजना और अनुमति"
        },
        htmlFor: "approved_building_plan",
        inputProps: {
          id: "approved_building_plan",
          name: "approved_building_plan",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Approved Building Plan and permissions granted is required.",
              hi: "अनुमोदित भवन योजना और अनुमति आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Valid CTO (Consent to Operation) issued by Uttarakhand Pollution Control Board (UKPCB)",
          hi: "उत्तराखंड प्रदूषण नियंत्रण बोर्ड (UKPCB) द्वारा जारी वैध CTO (ऑपरेशन की सहमति)"
        },
        htmlFor: "valid_cto_ukpcb",
        inputProps: {
          id: "valid_cto_ukpcb",
          name: "valid_cto_ukpcb",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Valid CTO (Consent to Operation) issued by UKPCB is required.",
              hi: "UKPCB द्वारा जारी वैध CTO (ऑपरेशन की सहमति) आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Copy of Completion/Occupancy Certificate",
          hi: "पूर्णता/अधिभोग प्रमाणपत्र की प्रति"
        },
        htmlFor: "completion_occupancy_certificate",
        inputProps: {
          id: "completion_occupancy_certificate",
          name: "completion_occupancy_certificate",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
            message: {
              en: "Copy of Completion/Occupancy Certificate is required.",
              hi: "पूर्णता/अधिभोग प्रमाणपत्र की प्रति आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Employee List with complete address with ID proof",
          hi: "कर्मचारी सूची (पूरा पता + आईडी प्रूफ सहित)"
        },
        htmlFor: "employee_list_with_id_proof",
        inputProps: {
          id: "employee_list_with_id_proof",
          name: "employee_list_with_id_proof",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Employee List with complete address with ID proof is required.",
              hi: "कर्मचारी सूची (पूरा पता + आईडी प्रूफ सहित) आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Incorporation document",
          hi: "निगम/पंजीकरण दस्तावेज़"
        },
        htmlFor: "incorporation_document",
        inputProps: {
          id: "incorporation_document",
          name: "incorporation_document",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Incorporation document is required.",
              hi: "निगम/पंजीकरण दस्तावेज़ आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Detailed Project Report (DPR)",
          hi: "विस्तृत परियोजना रिपोर्ट (DPR)"
        },
        htmlFor: "detailed_project_report",
        inputProps: {
          id: "detailed_project_report",
          name: "detailed_project_report",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Detailed Project Report (DPR) is required.",
              hi: "विस्तृत परियोजना रिपोर्ट (DPR) आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Loan Sanction Letter",
          hi: "बैंक ऋण स्वीकृति पत्र"
        },
        htmlFor: "bank_loan_sanction_letter",
        inputProps: {
          id: "bank_loan_sanction_letter",
          name: "bank_loan_sanction_letter",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Photographs of the unit/ Service",
          hi: "यूनिट/सेवा के फ़ोटो"
        },
        htmlFor: "photographs_of_the_unit_service",
        inputProps: {
          id: "photographs_of_the_unit_service",
          name: "photographs_of_the_unit_service",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Photographs of the unit/ Service is required.",
              hi: "यूनिट/सेवा के फ़ोटो आवश्यक हैं।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Affidavit",
          hi: "शपथपत्र (Affidavit)"
        },
        htmlFor: "affidavit",
        inputProps: {
          id: "affidavit",
          name: "affidavit",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          formatDocument: AffidavitPDF,
          validation: {
            required: true,
            message: {
              en: "Affidavit is required.",
              hi: "शपथपत्र आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "GST Registration Document",
          hi: "GST पंजीकरण दस्तावेज़"
        },
        htmlFor: "gst_registration_document",
        inputProps: {
          id: "gst_registration_document",
          name: "gst_registration_document",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
            message: {
              en: "GST Registration Document is required.",
              hi: "GST पंजीकरण दस्तावेज़ आवश्यक है।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "NOC Fire Document",
          hi: "NOC Fire दस्तावेज़"
        },
        htmlFor: "noc_fire_document",
        inputProps: {
          id: "noc_fire_document",
          name: "noc_fire_document",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "NOC Fire Document is required.",
              hi: "NOC Fire दस्तावेज़ आवश्यक है।"
            },
          },
        },
      },
    ],
  },
];

export const incentiveClaimSection6 = [
  {
    title: { en: "Capital Subsidy", hi: "पूंजी अनुदान" },
    fields: [
      {
        divClass: "overflow-auto mb-4 px-2",
        label: "Capital Expenditure Details through Bank Transactions",
        htmlFor: "capital_expenditure_details_through_bank_transactions",
        inputProps: {
          type: "table",
          name: "capital_expenditure_details_through_bank_transactions",
          id: "capital_expenditure_details_through_bank_transactions",
          canAddMore: false,
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: "Vendor Name *",
              width: "20%",
              name: "firm_vendor_particulars",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9\s.&()-]{2,150}$/, // allow text, numbers, some special chars
                message: "Enter a valid firm/vendor/particulars name.",
              },
            },
            {
              label: "Type of Investment *",
              width: "15%",
              name: "type_of_investment",
              validation: {
                required: true,
                message: "Type of Investment is required.",
              },
            },
            {
              label: "Invoice Item",
              width: "15%",
              name: "invoice_item",
              validation: {
                required: false,
                pattern: /^.{2,150}$/, // at least 2 chars
                message: "Enter a valid Invoice Item.",
              },
            },
            {
              label: "Invoice No. *",
              width: "10%",
              name: "invoice_no",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9-\/]{1,50}$/, // letters, numbers, dash, slash
                message: "Enter a valid Invoice Number.",
              },
            },
            {
              label: "Invoice Date",
              width: "10%",
              name: "date_of_invoice",
              validation: {
                required: false,
                pattern: /^\d{4}-\d{2}-\d{2}$/, // yyyy-mm-dd
                message: "Enter a valid Date (YYYY-MM-DD).",
              },
            },
            {
              label: "GSTIN *",
              width: "15%",
              name: "gstin_number",
              validation: {
                required: true,
                pattern:
                  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/i,
                message: "Enter a valid GSTIN Number (15 characters).",
              },
            },
            {
              label: "Total Invoice Value (INR) *",
              width: "15%",
              name: "total_invoice_value",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/, // numbers with up to 2 decimals
                message: "Enter a valid Invoice Value.",
              },
            },
            {
              label: "Payment Date *",
              width: "10%",
              name: "date_of_payment",
              validation: {
                required: true,
                pattern: /^\d{4}-\d{2}-\d{2}$/, // yyyy-mm-dd
                message: "Enter a valid Date of Payment (YYYY-MM-DD).",
              },
            },
            {
              label: "Mode of Payment *",
              width: "10%",
              name: "mode_of_payment",
              validation: {
                required: true,
                message: "Mode of Payment is required.",
              },
            },
            {
              label: "Payment Reference No.",
              width: "15%",
              name: "payment_reference_no",
              validation: {
                required: false,
                pattern: /^[A-Za-z0-9-]{2,50}$/, // alphanumeric with dash
                message: "Enter a valid Payment Reference Number.",
              },
            },
            {
              label: "Amount of Payment (INR) *",
              width: "15%",
              name: "amount_of_payment",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/, // numbers with up to 2 decimals
                message: "Enter a valid Amount of Payment.",
              },
            },
            {
              label: "A/C Details From Which Payment Made",
              width: "20%",
              name: "account_details",
              validation: {
                required: false,
                pattern: /^.{5,100}$/, // min 5 chars, allow text/numbers
                message: "Enter valid A/C details.",
              },
            },
          ],
          rows: [
            {
              firm_vendor_particulars: "",
              type_of_investment: "",
              invoice_item: "",
              invoice_no: "",
              date_of_invoice: "",
              gstin_number: "",
              total_invoice_value: "",
              date_of_payment: "",
              mode_of_payment: "",
              payment_reference_no: "",
              amount_of_payment: "",
              account_details: "",
            },
          ],
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Capital Expenditure Amount",
          hi: "कुल खर्च व्यय राशि"
        },
        htmlFor: "total_capital_expenditure_amount",
        inputProps: {
          id: "total_capital_expenditure_amount",
          name: "total_capital_expenditure_amount",
          type: "text",
          placeholder: {
            en: "Total Capital Expenditure Amount",
            hi: "कुल खर्च  व्यय राशि"
          },
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Total Capital Expenditure Amount is required.",
              hi: "कुल खर्च व्यय राशि आवश्यक है।"
            },
          },
        },
      },
    ],
  },
  {
    title: { en: "Capital Investment", hi: "पूंजी निवेश" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Land (if admissible)",
          hi: "भूमि (यदि मान्य हो)"
        },
        htmlFor: "land_if_admissible",
        inputProps: {
          id: "land_if_admissible",
          name: "land_if_admissible",
          type: "text",
          placeholder: {
            en: "Enter amount",
            hi: "राशि दर्ज करें"
          },
          disabled: false,
          required: true,
          description: {
            en: "Land purchase cost/ Stamp Duty/Registration cost",
            hi: "भूमि खरीद लागत/ स्टाम्प शुल्क/पंजीकरण लागत"
          },
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter a valid number (up to 2 decimals).",
              hi: "एक मान्य संख्या दर्ज करें (अधिकतम 2 दशमलव तक)।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Building & Civil Works",
          hi: "भवन और नागरिक कार्य"
        },
        htmlFor: "building_civil_works",
        inputProps: {
          id: "building_civil_works",
          name: "building_civil_works",
          type: "text",
          placeholder: {
            en: "Enter amount",
            hi: "राशि दर्ज करें"
          },
          disabled: false,
          required: true,
          description: {
            en: "Building/Guest Rooms / Cottages/Reception / Lobby / Dining Area / Dormitories/ Parking, Pathways etc.",
            hi: "भवन/गेस्ट रूम/कॉटेज/रिसेप्शन/लॉबी/डाइनिंग एरिया/डॉर्मिटरी/पार्किंग, पथ आदि।"
          },
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter a valid number (up to 2 decimals).",
              hi: "एक मान्य संख्या दर्ज करें (अधिकतम 2 दशमलव तक)।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Plant & Machinery",
          hi: "प्लांट और मशीनरी"
        },
        htmlFor: "plant_machinery",
        inputProps: {
          id: "plant_machinery",
          name: "plant_machinery",
          type: "text",
          placeholder: {
            en: "Enter amount",
            hi: "राशि दर्ज करें"
          },
          disabled: false,
          required: true,
          description: {
            en: "Kitchen & Laundry Equipment/DG Set / Solar / Power Backup/Air Conditioning / Heating System/ IT Systems (CCTV, Security, Property Management Software)",
            hi: "किचन और लॉन्ड्री उपकरण/DG सेट/सोलर/पावर बैकअप/एयर कंडीशनिंग/हीटिंग सिस्टम/आईटी सिस्टम (CCTV, सुरक्षा, प्रॉपर्टी मैनेजमेंट सॉफ्टवेयर)"
          },
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter a valid number (up to 2 decimals).",
              hi: "एक मान्य संख्या दर्ज करें (अधिकतम 2 दशमलव तक)।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Furniture & Fixtures",
          hi: "फर्नीचर और फिटिंग्स"
        },
        htmlFor: "furniture_fixtures",
        inputProps: {
          id: "furniture_fixtures",
          name: "furniture_fixtures",
          type: "text",
          placeholder: {
            en: "Enter amount",
            hi: "राशि दर्ज करें"
          },
          disabled: false,
          required: true,
          description: {
            en: "Room Furniture (Beds, Tables, Chairs, Wardrobes)/Restaurant Furniture (Dining Sets, Sofas, etc.)/Lighting & Decorative Fixtures",
            hi: "कमरे का फर्नीचर (बेड, टेबल, कुर्सियाँ, वार्डरोब)/रेस्टोरेंट फर्नीचर (डाइनिंग सेट, सोफा आदि)/लाइटिंग और सजावटी फिटिंग्स"
          },
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter a valid number (up to 2 decimals).",
              hi: "एक मान्य संख्या दर्ज करें (अधिकतम 2 दशमलव तक)।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Utilities & Infrastructure",
          hi: "यूटिलिटी और अवसंरचना"
        },
        htmlFor: "utilities_infrastructure",
        inputProps: {
          id: "utilities_infrastructure",
          name: "utilities_infrastructure",
          type: "text",
          placeholder: {
            en: "Enter amount",
            hi: "राशि दर्ज करें"
          },
          disabled: false,
          required: true,
          description: {
            en: "Water Supply, Borewell, Overhead Tank/Sewage Treatment Plant (STP) / Effluent Treatment Plant (ETP)/Electrical Transformer /Fire Safety System/Extinguishers",
            hi: "पानी की आपूर्ति, बोरवेल, ओवरहेड टैंक/सीवेज ट्रीटमेंट प्लांट (STP)/एफ्लुएंट ट्रीटमेंट प्लांट (ETP)/इलेक्ट्रिकल ट्रांसफॉर्मर/फायर सेफ्टी सिस्टम/एग्जिंग्गुइशर"
          },
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter a valid number (up to 2 decimals).",
              hi: "एक मान्य संख्या दर्ज करें (अधिकतम 2 दशमलव तक)।"
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Other Expenses",
          hi: "अन्य खर्च"
        },
        htmlFor: "other_expenses",
        inputProps: {
          id: "other_expenses",
          name: "other_expenses",
          type: "text",
          placeholder: {
            en: "Enter amount",
            hi: "राशि दर्ज करें"
          },
          disabled: false,
          required: true,
          description: {
            en: "Adventure / Tourism-specific Equipment (Raft, Trekking Gear, Ropeway Components, Spa Equipment, Boats, etc.)/Solid Waste Management / Eco-friendly Measures",
            hi: "एडवेंचर/पर्यटन-विशिष्ट उपकरण (राफ्ट, ट्रेकिंग गियर, रोपवे कंपोनेंट्स, स्पा उपकरण, नाव आदि)/ठोस अपशिष्ट प्रबंधन/पर्यावरण-हितैषी उपाय"
          },
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: {
              en: "Enter a valid number (up to 2 decimals).",
              hi: "एक मान्य संख्या दर्ज करें (अधिकतम 2 दशमलव तक)।"
            },
          },
        },
      },
    ],
  },
  {
    title: { en: "Total Investment", hi: "कुल निवेश" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Investment",
          hi: "कुल निवेश"
        },
        htmlFor: "total_investment",
        inputProps: {
          id: "total_investment",
          name: "total_investment",
          type: "text",
          placeholder: {
            en: "Total Investment",
            hi: "कुल निवेश"
          },
          disabled: true,
          required: false,
          validation: {
            required: true,
            message: {
              en: "Total Investment is required",
              hi: "कुल निवेश आवश्यक है"
            },
          },
        },
      },
    ],
  },
  {
    title: "Amount to be Excluded (Non eligible Investment)",
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Expenses prior to In-Principal Approval (Period)", hi: "इन-प्रिंसिपल अप्रूवल से पहले के खर्च (अवधि)" },
        htmlFor: "expenses_prior_in_principal",
        inputProps: {
          id: "expenses_prior_in_principal",
          name: "expenses_prior_in_principal",
          type: "text",
          placeholder: { en: "Enter Expenses prior to In-Principal Approval", hi: "इन-प्रिंसिपल अप्रूवल से पहले खर्च दर्ज करें" },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Enter expenses as a number (up to 2 decimals).", hi: "खर्च संख्या में दर्ज करें (2 दशमलव तक)।" },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Expenses of which bills are not available after In-Principal Approval", hi: "इन-प्रिंसिपल अप्रूवल के बाद जिन खर्चों के बिल उपलब्ध नहीं हैं" },
        htmlFor: "expenses_no_bills_after_in_principal",
        inputProps: {
          id: "expenses_no_bills_after_in_principal",
          name: "expenses_no_bills_after_in_principal",
          type: "text",
          placeholder: { en: "Enter Expenses without bills", hi: "बिल के बिना खर्च दर्ज करें" },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Enter expenses as a number (up to 2 decimals).", hi: "खर्च संख्या में दर्ज करें (2 दशमलव तक)।" },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Expenses paid in cash and other sources", hi: "नकद और अन्य स्रोतों से भुगतान किए गए खर्च" },
        htmlFor: "expenses_paid_cash_other",
        inputProps: {
          id: "expenses_paid_cash_other",
          name: "expenses_paid_cash_other",
          type: "text",
          placeholder: { en: "Enter Expenses paid in cash/other sources", hi: "नकद/अन्य स्रोतों से खर्च दर्ज करें" },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Enter expenses as a number (up to 2 decimals).", hi: "खर्च संख्या में दर्ज करें (2 दशमलव तक)।" },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Cost of Land & Stamp Duty", hi: "भूमि की लागत और स्टाम्प ड्यूटी" },
        htmlFor: "cost_land_stamp_duty",
        inputProps: {
          id: "cost_land_stamp_duty",
          name: "cost_land_stamp_duty",
          type: "text",
          placeholder: { en: "Enter Cost of Land & Stamp Duty", hi: "भूमि की लागत और स्टाम्प ड्यूटी दर्ज करें" },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Enter cost as a number (up to 2 decimals).", hi: "लागत संख्या में दर्ज करें (2 दशमलव तक)।" },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Cost of consultancy fees and other taxes", hi: "सलाहकार शुल्क और अन्य करों की लागत" },
        htmlFor: "cost_consultancy_other_taxes",
        inputProps: {
          id: "cost_consultancy_other_taxes",
          name: "cost_consultancy_other_taxes",
          type: "text",
          placeholder: { en: "Enter Cost of consultancy fees & taxes", hi: "सलाहकार शुल्क और करों की लागत दर्ज करें" },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Enter cost as a number (up to 2 decimals).", hi: "लागत संख्या में दर्ज करें (2 दशमलव तक)।" },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Site development as per Valuation", hi: "मूल्यांकन के अनुसार साइट विकास" },
        htmlFor: "site_development_valuation",
        inputProps: {
          id: "site_development_valuation",
          name: "site_development_valuation",
          type: "text",
          placeholder: { en: "Enter Site development cost", hi: "साइट विकास लागत दर्ज करें" },
          disabled: false,
          required: true,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Enter cost as a number (up to 2 decimals).", hi: "लागत संख्या में दर्ज करें (2 दशमलव तक)।" },
          },
        },
      },
    ],
  },
  {
    title: { en: "Total (Non Eligible)", hi: "कुल (अयोग्य)" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: { en: "Total (Non Eligible)", hi: "कुल (अयोग्य)" },
        htmlFor: "total_non_eligible",
        inputProps: {
          id: "total_non_eligible",
          name: "total_non_eligible",
          type: "text",
          placeholder: { en: "Total (Non Eligible)", hi: "कुल (अयोग्य)" },
          disabled: true,
          required: false,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: { en: "Total (Non Eligible) is required.", hi: "कुल (अयोग्य) आवश्यक है।" },
          },
        },
      },
    ],
  },
  {
    title: { en: "Total Eligible Investment (After deduction of non-eligible)", hi: "कुल पात्र निवेश (अयोग्य कटौती के बाद)" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Eligible Investment",
          hi: "कुल पात्र निवेश",
        },
        htmlFor: "total_eligible_investment_after_non_eligible_deduction",
        inputProps: {
          id: "total_eligible_investment_after_non_eligible_deduction",
          name: "total_eligible_investment_after_non_eligible_deduction",
          type: "text",
          placeholder: {
            en: "Total Eligible Investment",
            hi: "कुल पात्र निवेश",
          },
          disabled: true,
          required: false,
          validation: {
            required: true,
            pattern: /^\d+(\.\d{1,2})?\s*[a-zA-Z\s]*$/,
            message: {
              en: "Total Eligible Investment (After deduction of non-eligible) is required",
              hi: "कुल पात्र निवेश (अयोग्य कटौती के बाद) आवश्यक है",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Maximum Eligible Investment for Subsidy",
          hi: "सब्सिडी के लिए अधिकतम पात्र निवेश",
        },
        htmlFor: "maximum_eligible_subsidy_investment",
        inputProps: {
          id: "maximum_eligible_subsidy_investment",
          name: "maximum_eligible_subsidy_investment",
          type: "text",
          placeholder: {
            en: "Maximum Eligible Investment for Subsidy",
            hi: "सब्सिडी के लिए अधिकतम पात्र निवेश",
          },
          disabled: true,
          required: false,
          validation: {
            required: true,
            message: {
              en: "Maximum Eligible Investment for Subsidy is required",
              hi: "सब्सिडी के लिए अधिकतम पात्र निवेश आवश्यक है",
            },
          },
        },
      },
    ],
  },
  {
    title: { en: "Tentative Capital Subsidy", hi: "अनुमानित पूंजी सब्सिडी" },
    fields: [
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Capital Subsidy For Min Investment (1 Cr.)",
          hi: "न्यूनतम निवेश (1 Cr.) के लिए पूंजी सब्सिडी",
        },
        htmlFor: "capital_subsidy_min_investment",
        inputProps: {
          id: "capital_subsidy_min_investment",
          name: "capital_subsidy_min_investment",
          type: "text",
          placeholder: {
            en: "Enter Capital Subsidy for Min Investment",
            hi: "न्यूनतम निवेश के लिए पूंजी सब्सिडी दर्ज करें",
          },
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Capital Subsidy For Min Investment is required",
              hi: "न्यूनतम निवेश के लिए पूंजी सब्सिडी आवश्यक है",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Capital Subsidy For Additional Investment (<1 & >5Cr.)",
          hi: "अतिरिक्त निवेश (<1 & >5Cr.) के लिए पूंजी सब्सिडी",
        },
        htmlFor: "capital_subsidy_additional_investment",
        inputProps: {
          id: "capital_subsidy_additional_investment",
          name: "capital_subsidy_additional_investment",
          type: "text",
          placeholder: {
            en: "Enter Capital Subsidy for Additional Investment",
            hi: "अतिरिक्त निवेश के लिए पूंजी सब्सिडी दर्ज करें",
          },
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Capital Subsidy For Additional Investment is required",
              hi: "अतिरिक्त निवेश के लिए पूंजी सब्सिडी आवश्यक है",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Maximum Capital Subsidy",
          hi: "कुल अधिकतम पूंजी सब्सिडी",
        },
        htmlFor: "total_max_capital_subsidy",
        inputProps: {
          id: "total_max_capital_subsidy",
          name: "total_max_capital_subsidy",
          type: "text",
          placeholder: {
            en: "Enter Total Maximum Capital Subsidy",
            hi: "कुल अधिकतम पूंजी सब्सिडी दर्ज करें",
          },
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Total Maximum Capital Subsidy is required",
              hi: "कुल अधिकतम पूंजी सब्सिडी आवश्यक है",
            },
          },
        },
      },
    ],
  },
  {
    title: { en: "Documents", hi: "दस्तावेज़" },
    fields: [
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "CA certificate For CAPEX",
          hi: "CAPEX के लिए CA प्रमाणपत्र",
        },
        htmlFor: "ca_certificate_capex",
        inputProps: {
          id: "ca_certificate_capex",
          name: "ca_certificate_capex",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: true,
          formatDocument: CACertificatePDF,
          validation: {
            required: true,
            message: {
              en: "CA certificate For CAPEX is required.",
              hi: "CAPEX के लिए CA प्रमाणपत्र आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Actual Bills as per Capital Expenditure",
          hi: "पूंजी व्यय के अनुसार वास्तविक बिल",
        },
        htmlFor: "actual_bills_capex",
        inputProps: {
          id: "actual_bills_capex",
          name: "actual_bills_capex",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Actual Bills as per Capital Expenditure are required.",
              hi: "पूंजी व्यय के अनुसार वास्तविक बिल आवश्यक हैं।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Transaction Proofs Document-1",
          hi: "बैंक लेनदेन प्रमाण दस्तावेज-1",
        },
        htmlFor: "bank_transaction_proof_1",
        inputProps: {
          id: "bank_transaction_proof_1",
          name: "bank_transaction_proof_1",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Bank Transaction Proof Document-1 is required.",
              hi: "बैंक लेनदेन प्रमाण दस्तावेज-1 आवश्यक है।",
            },
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Transaction Proofs Document-2",
          hi: "बैंक लेनदेन प्रमाण दस्तावेज-2",
        },
        htmlFor: "bank_transaction_proof_2",
        inputProps: {
          id: "bank_transaction_proof_2",
          name: "bank_transaction_proof_2",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Transaction Proofs Document-3",
          hi: "बैंक लेनदेन प्रमाण दस्तावेज-3",
        },
        htmlFor: "bank_transaction_proof_3",
        inputProps: {
          id: "bank_transaction_proof_3",
          name: "bank_transaction_proof_3",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Transaction Proofs Document-4",
          hi: "बैंक लेनदेन प्रमाण दस्तावेज-4",
        },
        htmlFor: "bank_transaction_proof_4",
        inputProps: {
          id: "bank_transaction_proof_4",
          name: "bank_transaction_proof_4",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Transaction Proofs Document-5",
          hi: "बैंक लेनदेन प्रमाण दस्तावेज-5",
        },
        htmlFor: "bank_transaction_proof_5",
        inputProps: {
          id: "bank_transaction_proof_5",
          name: "bank_transaction_proof_5",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Chartered Engineer certificate of valuation",
          hi: "मूल्यांकन का चार्टर्ड इंजीनियर प्रमाणपत्र",
        },
        htmlFor: "chartered_engineer_certificate",
        inputProps: {
          id: "chartered_engineer_certificate",
          name: "chartered_engineer_certificate",
          type: "file",
          placeholder: {
            en: "",
            hi: "",
          },
          disabled: false,
          formatDocument: CEArchitectPDF,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Chartered Engineer certificate of valuation is required.",
              hi: "मूल्यांकन का चार्टर्ड इंजीनियर प्रमाणपत्र आवश्यक है।",
            },
          },
        },
      },
    ],
  },
];

export const incentiveClaimSection7 = [
  {
    title: { en: "Bank Details Section", hi: "बैंक विवरण अनुभाग" },
    fields: [
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Loan & Interest Details – First Installment",
          hi: "ऋण एवं ब्याज विवरण – प्रथम किस्त"
        },
        htmlFor: "loan_interest_details_interest_subsidy_first_installment",
        inputProps: {
          type: "table",
          name: "loan_interest_details_interest_subsidy_first_installment",
          id: "loan_interest_details_interest_subsidy_first_installment",
          canAddMore: true,
          tableClass: "border border-gray-400 divide-y divide-gray-200 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          disabled: true,
          headers: [
            {
              label: { en: "Name of the Bank", hi: "बैंक का नाम" },
              width: "15%",
              name: "bank_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\u0900-\u097F\s]{2,100}$/,
                message: {
                  en: "Enter a valid bank name.",
                  hi: "मान्य बैंक नाम दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Account Number", hi: "खाता संख्या" },
              width: "10%",
              name: "account_number",
              validation: {
                required: true,
                pattern: /^[0-9]{9,18}$/,
                message: {
                  en: "Enter a valid bank account number (9–18 digits).",
                  hi: "मान्य खाता संख्या दर्ज करें (9–18 अंक)।"
                }
              }
            },
            {
              label: { en: "Account Holder's Name", hi: "खाता धारक का नाम" },
              width: "15%",
              name: "account_holder_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\u0900-\u097F\s]{2,100}$/,
                message: {
                  en: "Enter a valid account holder name.",
                  hi: "मान्य खाता धारक का नाम दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Loan Disbursed Amount", hi: "ऋण वितरित राशि" },
              width: "10%",
              name: "loan_disbursed_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid disbursed amount (up to 2 decimals).",
                  hi: "मान्य वितरित राशि दर्ज करें (2 दशमलव तक)।"
                }
              }
            },
            {
              label: { en: "Interest Period Start Date", hi: "ब्याज अवधि प्रारंभ तिथि" },
              width: "10%",
              name: "interest_start_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Start Date is required.",
                  hi: "प्रारंभ तिथि आवश्यक है।"
                }
              }
            },
            {
              label: { en: "Interest Period End Date", hi: "ब्याज अवधि समाप्ति तिथि" },
              width: "10%",
              name: "interest_end_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "End Date is required.",
                  hi: "समाप्ति तिथि आवश्यक है।"
                }
              }
            },
            {
              label: { en: "Principal Amount Paid", hi: "चुकाई गई मूलधन राशि" },
              width: "10%",
              name: "principal_paid",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid principal amount.",
                  hi: "मान्य मूलधन राशि दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Interest Amount Paid", hi: "चुकाया गया ब्याज" },
              width: "10%",
              name: "interest_paid",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid interest amount.",
                  hi: "मान्य ब्याज राशि दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Penal Amount (if any)", hi: "दंड राशि (यदि कोई हो)" },
              width: "10%",
              name: "panel_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid penal amount.",
                  hi: "मान्य दंड राशि दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Total Interest (excluding Penal Amount)",
                hi: "कुल ब्याज (दंड राशि को छोड़कर)"
              },
              width: "10%",
              name: "total_interest",
              disabled: true,
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Total interest amount is required.",
                  hi: "कुल ब्याज राशि आवश्यक है।"
                }
              }
            },
            {
              label: { en: "Date of Payment", hi: "भुगतान की तिथि" },
              width: "10%",
              name: "payment_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Payment Date is required.",
                  hi: "भुगतान की तिथि आवश्यक है।"
                }
              }
            }
          ],

          rows: [
            {
              bank_name: "",
              account_number: "",
              account_holder_name: "",
              loan_disbursed_amount: "",
              interest_start_date: "",
              interest_end_date: "",
              principal_paid: "",
              interest_paid: "",
              panel_amount: "",
              total_interest: "",
              payment_date: ""
            }
          ]
        }
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: { en: "Total Interest Paid", hi: "कुल चुकाया गया ब्याज" },
        htmlFor: "total_interest_paid_first_installment",
        inputProps: {
          id: "total_interest_paid_first_installment",
          name: "total_interest_paid_first_installment",
          type: "text",
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Total interest paid is required.",
              hi: "कुल चुकाया गया ब्याज आवश्यक है।"
            }
          }
        }
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: { en: "Maximum Eligible Amount", hi: "अधिकतम पात्र राशि" },
        htmlFor: "maximum_eligible_amount_first_installment",
        inputProps: {
          id: "maximum_eligible_amount_first_installment",
          name: "maximum_eligible_amount_first_installment",
          type: "text",
          disabled: true,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Maximum eligible amount is required.",
              hi: "अधिकतम पात्र राशि आवश्यक है।"
            }
          }
        }
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Loan & Interest Details Second Installment",
          hi: "ऋण एवं ब्याज विवरण (दूसरी किस्त)"
        },
        htmlFor: "loan_interest_details_interest_subsidy_second_installment",
        inputProps: {
          type: "table",
          name: "loan_interest_details_interest_subsidy_second_installment",
          id: "loan_interest_details_interest_subsidy_second_installment",
          canAddMore: true,
          tableClass: "border border-gray-400 divide-y divide-gray-200 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          disabled: true,

          headers: [
            {
              label: {
                en: "Name of the Bank",
                hi: "बैंक का नाम"
              },
              width: "15%",
              name: "bank_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid bank name (only letters).",
                  hi: "कृपया मान्य बैंक का नाम दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Account Number",
                hi: "खाता संख्या"
              },
              width: "10%",
              name: "account_number",
              validation: {
                required: true,
                pattern: /^[0-9]{9,18}$/,
                message: {
                  en: "Enter a valid bank account number (9–18 digits).",
                  hi: "कृपया मान्य खाता संख्या दर्ज करें (9–18 अंक)।"
                }
              }
            },
            {
              label: {
                en: "Account Holder's Name",
                hi: "खाता धारक का नाम"
              },
              width: "15%",
              name: "account_holder_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid account holder name.",
                  hi: "कृपया मान्य खाता धारक का नाम दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Loan Disbursed Amount",
                hi: "वितरित ऋण राशि"
              },
              width: "10%",
              name: "loan_disbursed_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid disbursed amount.",
                  hi: "कृपया मान्य वितरित राशि दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Interest Period Start Date",
                hi: "ब्याज अवधि प्रारंभ तिथि"
              },
              width: "10%",
              name: "interest_start_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Start Date is required.",
                  hi: "प्रारंभ तिथि आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Interest Period End Date",
                hi: "ब्याज अवधि समाप्ति तिथि"
              },
              width: "10%",
              name: "interest_end_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "End Date is required.",
                  hi: "समाप्ति तिथि आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Principal Amount Paid to Bank",
                hi: "बैंक को चुकाई गई मूलधन राशि"
              },
              width: "10%",
              name: "principal_paid",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid principal amount.",
                  hi: "कृपया मान्य मूलधन राशि दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Interest Amount Paid to Bank",
                hi: "बैंक को चुकाई गई ब्याज राशि"
              },
              width: "10%",
              name: "interest_paid",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid interest amount.",
                  hi: "कृपया मान्य ब्याज राशि दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Panel Amount (if any)",
                hi: "पेनल राशि (यदि कोई हो)"
              },
              width: "10%",
              name: "panel_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid panel amount.",
                  hi: "कृपया मान्य पेनल राशि दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Total Interest (excluding Panel Amount)",
                hi: "कुल ब्याज (पेनल राशि को छोड़कर)"
              },
              width: "10%",
              name: "total_interest",
              disabled: true,
              validation: {
                required: true,
                message: {
                  en: "Total interest is required.",
                  hi: "कुल ब्याज आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Date of Payment",
                hi: "भुगतान की तिथि"
              },
              width: "10%",
              name: "payment_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Payment Date is required.",
                  hi: "भुगतान तिथि आवश्यक है।"
                }
              }
            }
          ],

          rows: [
            {
              bank_name: "",
              account_number: "",
              account_holder_name: "",
              loan_disbursed_amount: "",
              interest_start_date: "",
              interest_end_date: "",
              principal_paid: "",
              interest_paid: "",
              panel_amount: "",
              total_interest: "",
              payment_date: ""
            }
          ]
        }
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Interest Paid",
          hi: "कुल चुकाया गया ब्याज"
        },
        htmlFor: "total_interest_paid_second_installment",
        inputProps: {
          id: "total_interest_paid_second_installment",
          name: "total_interest_paid_second_installment",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: {
            required: true
          }
        }
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Maximum Eligible Amount",
          hi: "अधिकतम पात्र राशि"
        },
        htmlFor: "maximum_eligible_amount_second_installment",
        inputProps: {
          id: "maximum_eligible_amount_second_installment",
          name: "maximum_eligible_amount_second_installment",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: {
            required: true
          }
        }
      },
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "Loan & Interest Details Third Installment",
          hi: "ऋण एवं ब्याज विवरण (तीसरी किस्त)"
        },
        htmlFor: "loan_interest_details_interest_subsidy_third_installment",
        inputProps: {
          type: "table",
          name: "loan_interest_details_interest_subsidy_third_installment",
          id: "loan_interest_details_interest_subsidy_third_installment",
          canAddMore: true,
          tableClass: "border border-gray-400 divide-y divide-gray-200 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          disabled: true,
          headers: [
            {
              label: { en: "Name of the Bank", hi: "बैंक का नाम" },
              width: "15%",
              name: "bank_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid bank name (only letters).",
                  hi: "कृपया मान्य बैंक का नाम दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Account Number", hi: "खाता संख्या" },
              width: "10%",
              name: "account_number",
              validation: {
                required: true,
                pattern: /^[0-9]{9,18}$/,
                message: {
                  en: "Enter a valid bank account number (9–18 digits).",
                  hi: "कृपया मान्य खाता संख्या दर्ज करें (9–18 अंक)।"
                }
              }
            },
            {
              label: { en: "Account Holder's Name", hi: "खाता धारक का नाम" },
              width: "15%",
              name: "account_holder_name",
              validation: {
                required: true,
                pattern: /^[A-Za-z\s\u0900-\u097F]{2,100}$/,
                message: {
                  en: "Enter a valid account holder name.",
                  hi: "कृपया मान्य खाता धारक का नाम दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Loan Disbursed Amount", hi: "वितरित ऋण राशि" },
              width: "10%",
              name: "loan_disbursed_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid disbursed amount.",
                  hi: "कृपया मान्य वितरित राशि दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Interest Period Start Date", hi: "ब्याज अवधि प्रारंभ तिथि" },
              width: "10%",
              name: "interest_start_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Start Date is required.",
                  hi: "प्रारंभ तिथि आवश्यक है।"
                }
              }
            },
            {
              label: { en: "Interest Period End Date", hi: "ब्याज अवधि समाप्ति तिथि" },
              width: "10%",
              name: "interest_end_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "End Date is required.",
                  hi: "समाप्ति तिथि आवश्यक है।"
                }
              }
            },
            {
              label: { en: "Principal Amount Paid to Bank", hi: "बैंक को चुकाई गई मूलधन राशि" },
              width: "10%",
              name: "principal_paid",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid principal amount.",
                  hi: "कृपया मान्य मूलधन राशि दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Interest Amount Paid to Bank", hi: "बैंक को चुकाई गई ब्याज राशि" },
              width: "10%",
              name: "interest_paid",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid interest amount.",
                  hi: "कृपया मान्य ब्याज राशि दर्ज करें।"
                }
              }
            },
            {
              label: { en: "Panel Amount (if any)", hi: "पेनल राशि (यदि कोई हो)" },
              width: "10%",
              name: "panel_amount",
              validation: {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
                message: {
                  en: "Enter a valid panel amount.",
                  hi: "कृपया मान्य पेनल राशि दर्ज करें।"
                }
              }
            },
            {
              label: {
                en: "Total Interest (excluding Panel Amount)",
                hi: "कुल ब्याज (पेनल राशि को छोड़कर)"
              },
              width: "10%",
              name: "total_interest",
              disabled: true,
              validation: {
                required: true,
                message: {
                  en: "Total interest is required.",
                  hi: "कुल ब्याज आवश्यक है।"
                }
              }
            },
            {
              label: { en: "Date of Payment", hi: "भुगतान की तिथि" },
              width: "10%",
              name: "payment_date",
              type: "date",
              validation: {
                required: true,
                message: {
                  en: "Payment Date is required.",
                  hi: "भुगतान तिथि आवश्यक है।"
                }
              }
            }
          ],

          rows: [
            {
              bank_name: "",
              account_number: "",
              account_holder_name: "",
              loan_disbursed_amount: "",
              interest_start_date: "",
              interest_end_date: "",
              principal_paid: "",
              interest_paid: "",
              panel_amount: "",
              total_interest: "",
              payment_date: ""
            }
          ]
        }
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Interest Paid",
          hi: "कुल चुकाया गया ब्याज"
        },
        htmlFor: "total_interest_paid_third_installment",
        inputProps: {
          id: "total_interest_paid_third_installment",
          name: "total_interest_paid_third_installment",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: { required: true }
        }
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Maximum Eligible Amount",
          hi: "अधिकतम पात्र राशि"
        },
        htmlFor: "maximum_eligible_amount_third_installment",
        inputProps: {
          id: "maximum_eligible_amount_third_installment",
          name: "maximum_eligible_amount_third_installment",
          type: "text",
          placeholder: "",
          disabled: true,
          required: true,
          validation: { required: true }
        }
      },
    ],
  },
  {
    title: { en: "Interest Subsidy Documents", hi: "ब्याज सब्सिडी दस्तावेज़" },
    fields: [
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank / financial Institution’s loan sanction letter (only NBFCs and Scheduled Banks)",
          hi: "बैंक / वित्तीय संस्था का ऋण स्वीकृति पत्र (केवल एनबीएफसी और अनुसूचित बैंक)"
        },
        htmlFor: "bank_financial_institution_loan_sanction_letter",
        inputProps: {
          id: "bank_financial_institution_loan_sanction_letter",
          name: "bank_financial_institution_loan_sanction_letter",
          type: "file",
          placeholder: "",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Bank / financial institution’s loan sanction letter is required.",
              hi: "बैंक / वित्तीय संस्था का ऋण स्वीकृति पत्र आवश्यक है।"
            }
          }
        }
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Proof of payment of interest and principal amount to bank",
          hi: "बैंक को ब्याज एवं मूलधन भुगतान का प्रमाण"
        },
        htmlFor: "proof_payment_interest_principal_bank",
        inputProps: {
          id: "proof_payment_interest_principal_bank",
          name: "proof_payment_interest_principal_bank",
          type: "file",
          placeholder: "",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Proof of payment of interest and principal amount to bank is required.",
              hi: "बैंक को ब्याज एवं मूलधन भुगतान का प्रमाण आवश्यक है।"
            }
          }
        }
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank certificate Stating Annual Interest Payment and No Default Towards Loan Repayment",
          hi: "वार्षिक ब्याज भुगतान एवं ऋण चुकौती में कोई चूक न होने का बैंक प्रमाण पत्र"
        },
        htmlFor: "bank_certificate_annual_interest_payment",
        inputProps: {
          id: "bank_certificate_annual_interest_payment",
          name: "bank_certificate_annual_interest_payment",
          type: "file",
          placeholder: "",
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: {
              en: "Bank certificate stating annual interest payment and no default is required.",
              hi: "वार्षिक ब्याज भुगतान एवं कोई चूक न होने का बैंक प्रमाण पत्र आवश्यक है।"
            }
          }
        }
      },
    ],
  },
];

export const incentiveClaimSection8 = [
  {
    title: { en: "Stamp Duty", hi: "स्टाम्प शुल्क" },
    fields: [
      {
        divClass: "overflow-auto mb-4 px-2",
        label: {
          en: "",
          hi: ""
        },
        htmlFor: "stamp_duty_for_first_installment_details",
        inputProps: {
          type: "table",
          name: "stamp_duty_for_first_installment_details",
          id: "stamp_duty_for_first_installment_details",
          canAddMore: true,
          tableClass:
            "border border-gray-400 divide-y divide-gray-200 border border-gray-300 w-full",
          headerBg: "bg-[#e5f5f4]",
          headerClass: "border border-gray-400 p-2 text-center",
          rowClass: "border border-gray-400 p-2 text-gray-700",
          headers: [
            {
              label: {
                en: "PDE No",
                hi: "पीडीई संख्या"
              },
              width: "15%",
              name: "pde_no",
              validation: {
                required: false,
                minLength: 15,
                pattern: /^[A-Za-z0-9-\/]{15,50}$/,
                message: {
                  en: "Enter a valid PDE Number (min 15 chars).",
                  hi: "मान्य पीडीई संख्या दर्ज करें (न्यूनतम 15 अक्षर)।"
                }
              }
            },
            {
              label: {
                en: "Khatoni",
                hi: "खतौनी"
              },
              width: "10%",
              name: "khatoni",
              disabled: false,
              validation: {
                required: false,
                message: {
                  en: "Khatoni is optional.",
                  hi: "खतौनी वैकल्पिक है।"
                }
              }
            },
            {
              label: {
                en: "Khasra",
                hi: "खसरा"
              },
              width: "10%",
              name: "khasra",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "Khasra is required.",
                  hi: "खसरा आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "District",
                hi: "जिला"
              },
              width: "10%",
              name: "district",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "District is required.",
                  hi: "जिला आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Location",
                hi: "स्थान"
              },
              width: "10%",
              name: "location",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "Location is required.",
                  hi: "स्थान आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Buyer",
                hi: "क्रेता"
              },
              width: "10%",
              name: "buyer",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "Buyer is required.",
                  hi: "क्रेता आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Seller",
                hi: "विक्रेता"
              },
              width: "10%",
              name: "seller",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "Seller is required.",
                  hi: "विक्रेता आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Stamp Duty (INR)",
                hi: "स्टाम्प शुल्क (रुपये)"
              },
              width: "10%",
              name: "stamp_duty",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "Stamp Duty is required.",
                  hi: "स्टाम्प शुल्क आवश्यक है।"
                }
              }
            },
            {
              label: {
                en: "Registration Date",
                hi: "पंजीकरण तिथि"
              },
              width: "10%",
              name: "regdate",
              disabled: true,
              validation: {
                required: false,
                message: {
                  en: "Registration Date is required.",
                  hi: "पंजीकरण तिथि आवश्यक है।"
                }
              }
            }
          ],
          rows: [
            {
              pde_no: "",
              district: "",
              location: "",
              khasra: "",
              khatoni: "",
              buyer: "",
              seller: "",
              stamp_duty: "",
              regdate: ""
            }
          ]
        }
      },
      {
        divClass: "w-full lg:w-1/3 md:w-1/2 px-2 mb-4",
        label: {
          en: "Total Stamp Duty Paid Per Year (INR)",
          hi: "प्रति वर्ष कुल भुगतान किया गया स्टाम्प शुल्क (रुपये)"
        },
        htmlFor: "total_stamp_duty_per_year",
        inputProps: {
          id: "total_stamp_duty_per_year",
          name: "total_stamp_duty_per_year",
          type: "text",
          placeholder: {
            en: "Enter Total Stamp Duty Paid",
            hi: "कुल भुगतान किया गया स्टाम्प शुल्क दर्ज करें"
          },
          disabled: true,
          required: false,
          validation: {
            required: false,
            message: {
              en: "Total Stamp Duty Paid Per Year is required",
              hi: "प्रति वर्ष कुल स्टाम्प शुल्क आवश्यक है।"
            }
          }
        }
      },
    ],
  },
  {
    title: { en: "Stamp Duty Documents", hi: "स्टाम्प शुल्क दस्तावेज़" },
    fields: [
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "PDE Number Detail",
          hi: "पीडीई संख्या विवरण"
        },
        htmlFor: "pde_number_detail",
        inputProps: {
          id: "pde_number_detail",
          name: "pde_number_detail",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Transaction proofs of payment of stamp duty",
          hi: "स्टाम्प ड्यूटी भुगतान के बैंक लेन-देन प्रमाण"
        },
        htmlFor: "bank_proof_stamp_duty",
        inputProps: {
          id: "bank_proof_stamp_duty",
          name: "bank_proof_stamp_duty",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Copy of loan agreement / Copy of Mortgaged Deed clearly stating the objective of the loan being sanctioned / Mortgage",
          hi: "ऋण अनुबंध की प्रति / बंधक विलेख की प्रति जिसमें स्वीकृत ऋण / बंधक का उद्देश्य स्पष्ट रूप से उल्लेखित हो"
        },
        htmlFor: "loan_agreement_or_mortgaged_deed",
        inputProps: {
          id: "loan_agreement_or_mortgaged_deed",
          name: "loan_agreement_or_mortgaged_deed",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {
            required: false,
          },
        },
      },
    ],
  },
  {
    title: { en: "Tax Documents", hi: "कर दस्तावेज़" },
    fields: [
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "ITR Return File",
          hi: "आईटीआर रिटर्न फ़ाइल"
        },
        htmlFor: "itr_return_file_second_installment",
        inputProps: {
          id: "itr_return_file_second_installment",
          name: "itr_return_file_second_installment",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Electricity Bill (last six Month)",
          hi: "बिजली बिल (पिछले छह महीने)"
        },
        htmlFor: "electricity_bill_last_six_months_second_installment",
        inputProps: {
          id: "electricity_bill_last_six_months_second_installment",
          name: "electricity_bill_last_six_months_second_installment",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "GST Return File",
          hi: "जीएसटी रिटर्न फ़ाइल"
        },
        htmlFor: "gst_return_file_second_installment",
        inputProps: {
          id: "gst_return_file_second_installment",
          name: "gst_return_file_second_installment",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
          },
        },
      },
    ],
  },
  {
    title: { en: "Bank Details Regrading Subsidy Disbursement", hi: "सब्सिडी वितरण के बारे में बैंक विवरण" },
    fields: [
      {
        divClass: "w-full px-2 mb-4",
        label: {
          en: "Do you want to use the same bank details as those used in the Term Loan Bank Details?",
          hi: "क्या आप टर्म लोन बैंक विवरण में उपयोग किए गए वही बैंक विवरण उपयोग करना चाहते हैं?"
        },
        htmlFor: "use_same_details_as_term_loan",
        inputProps: {
          id: "use_same_details_as_term_loan",
          name: "use_same_details_as_term_loan",
          type: "checkbox",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: false,
          validation: {},
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "IFSC Code of the Branch",
          hi: "शाखा का IFSC कोड"
        },
        htmlFor: "subsidy_ifsc_code",
        inputProps: {
          id: "subsidy_ifsc_code",
          name: "subsidy_ifsc_code",
          type: "text",
          placeholder: {
            en: "Enter IFSC Code of the Branch",
            hi: "शाखा का IFSC कोड दर्ज करें"
          },
          required: true,
          validation: {
            required: true,
            pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
            message: "Enter a valid IFSC code (e.g., SBIN0001234).",
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Name of the Bank",
          hi: "बैंक का नाम"
        },
        htmlFor: "subsidy_bank_name",
        inputProps: {
          id: "subsidy_bank_name",
          name: "subsidy_bank_name",
          type: "text",
          placeholder: {
            en: "Enter Name of the Bank",
            hi: "बैंक का नाम दर्ज करें"
          },
          required: true,
          validation: {
            required: true,
            pattern: /^[A-Za-z0-9\s\u0900-\u097F]+$/,
            message: "Bank Name is required (letters/numbers allowed).",
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Branch Name",
          hi: "शाखा का नाम"
        },
        htmlFor: "subsidy_branch_name",
        inputProps: {
          id: "subsidy_branch_name",
          name: "subsidy_branch_name",
          type: "text",
          placeholder: {
            en: "Enter Branch Name",
            hi: "शाखा का नाम दर्ज करें"
          },
          required: true,
          validation: {
            required: true,
            pattern: /^[A-Za-z0-9\s\u0900-\u097F]+$/,
            message: "Branch Name is required (letters/numbers allowed).",
          },
        },
      },
      {
        divClass: "w-full lg:w-1/4 md:w-1/2 px-2 mb-4",
        label: {
          en: "Bank Account Number",
          hi: "बैंक खाता संख्या"
        },
        htmlFor: "subsidy_bank_account_number",
        inputProps: {
          id: "subsidy_bank_account_number",
          name: "subsidy_bank_account_number",
          type: "text",
          placeholder: {
            en: "Enter Bank Account Number",
            hi: "बैंक खाता संख्या दर्ज करें"
          },
          required: true,
          validation: {
            required: true,
            pattern: /^\d{6,18}$/,
            message: "Enter a valid Bank Account Number (6–18 digits).",
          },
        },
      },
      {
        divClass: "w-full lg:w-1/2 md:w-1/2 px-2 mb-4",
        label: {
          en: "Photocopy of Bank Passbook or Cancelled Check",
          hi: "बैंक पासबुक या रद्द किए गए चेक की छायाप्रति"
        },
        htmlFor: "photocopy_bank_passbook_cancelled_check",
        inputProps: {
          id: "photocopy_bank_passbook_cancelled_check",
          name: "photocopy_bank_passbook_cancelled_check",
          type: "file",
          placeholder: {
            en: "",
            hi: ""
          },
          disabled: false,
          required: true,
          validation: {
            required: true,
            message: "Photocopy of Bank Passbook or Cancelled Check is required.",
          },
        },
      },
    ],
  },
];

export const incentiveClaimSections = [
  { data: incentiveClaimSection1, title: { en: "Tourism Unit Detail", hi: "पर्यटन इकाई विवरण" } },
  { data: incentiveClaimSection2, title: { en: "Project Details", hi: "परियोजना विवरण" } },
  { data: incentiveClaimSection3, title: { en: "Loan Details", hi: "ऋण विवरण" } },
  {
    data: incentiveClaimSection4,
    title: { en: "Minimum Infra as per Policy Guidelines", hi: "नीति अनुसार न्यूनतम अवसंरचना" },
  },
  { data: incentiveClaimSection5, title: { en: "Required Documents", hi: "आवश्यक दस्तावेज़" } },
  { data: incentiveClaimSection6, title: { en: "Capital Subsidy", hi: "पूंजी अनुदान" } },
  { data: incentiveClaimSection7, title: { en: "Interest Subsidy", hi: "ब्याज अनुदान" } },
  { data: incentiveClaimSection8, title: { en: "Stamp Duty", hi: "स्टाम्प शुल्क" } },
];

export const incentiveClaimFormApplicationSampleData = {
  caf_id: "5118",
  financial_incentive_claim: "stampdutyreimbursement",
  unit_name: "Vadik Ganga",
  unit_address: "11 Dehradun, Dehradun",
  contact_no: "9999999999",
  registered_office: "Office Group",
  gst_registration_number: "27AAAAP0267H2ZN",
  travel_registration_date: "2025-08-22",
  uttr_no: "222134234324",
  nature_of_organization: "privateltdcompany",
  investor_details: [
    {
      name: "Ajay",
      designation: "Manager",
      share_holding: "50",
      mobile_number: "9999999999",
      pan_number: "EXDPH1234R",
      uttarakhandi_resident: "yes",
    },
    {
      name: "Vijay",
      designation: "Director",
      share_holding: "50",
      mobile_number: "9999999999",
      pan_number: "EXDPH1634R",
      uttarakhandi_resident: "yes",
    },
  ],
  project_type: "type1",
  commercial_operation_date: "2025-08-22",
  project_category: "category1",
  nic_code: "12345",
  tourism_product_name: "tourism product",
  project_type_name: "test",
  project_type_email: "",
  project_type_mobile: "8888888888",
  land_type: "type2",
  land_address: "123 Dehradun, Dehradun",
  mauja: "mauja",
  kharsa_raqwa_number: "12321",
  area_sqm: "2",
  registeration_allotment_date: "2025-08-22",
  original_lessee_department_name: "dep1",
  lessee_alloted_from_date: "2025-08-22",
  lessee_alloted_to_date: "2025-08-22",
  team_loan: "12333",
  promoter_contribution_equity: "22",
  unsecured_loan: "123334",
  other_source: "test",
  total_amount: "100",
  bank_name: "HDFC",
  branch_name: "Dehradun",
  loan_account_number: "12322323232",
  senctioned_loan_amount: "100000",
  loan_approval_date: "2025-08-22",
  total_loan_disbursed_amount: "300000",
  promoter_name: "Ajay",
  promoter_amount: "278777",
  promoter_pan_number: "EXDEE1234Q",
  promoter_payment_mode: "Check",
  unsecured_loan_name: "Test",
  unsecured_loan_amount: "1121212",
  unsecured_loan_pan_number: "EXDEE1234Q",
  unsecured_loan_payment_mode: "Check",
  major_component_of_infrastructure: "111",
  total_area_sqm: "133",
  build_up_area: "12",
  number_of_rooms: "2",
  parking_area: "122",
  resuarant_area: "100",
  mice_Facilities: "Pool",
  tourist_resort_activities: "Pool",
  resuarant_side_amenities: "Test",
  developed_facilities_amusement: "Pool",
  any_other_amenities: "No",
  electricity_approved_load: "500",
  electricity_connected_load: "500",
  power_plant_capacity: "1000",
};

export const incentiveClaimFormApplicationSampleData2 = {
  caf_id: "",
  financial_incentive_claim: "",
  unit_name: "",
  unit_address: "",
  contact_no: "",
  registered_office: "",
  gst_registration_number: "",
  travel_registration_date: "",
  uttr_no: "",
  nature_of_organization: "",
  investor_details: [
    {
      name: "",
      designation: "",
      share_holding: "",
      mobile_number: "",
      pan_number: "",
      uttarakhandi_resident: "",
    },
    {
      name: "",
      designation: "",
      share_holding: "",
      mobile_number: "",
      pan_number: "",
      uttarakhandi_resident: "",
    },
  ],
  project_type: "",
  commercial_operation_date: "",
  project_category: "",
  nic_code: "",
  tourism_product_name: "",
  project_type_name: "",
  project_type_email: "",
  project_type_mobile: "",
  land_type: "",
  land_address: "",
  mauja: "",
  kharsa_raqwa_number: "",
  area_sqm: "",
  registeration_allotment_date: "",
  original_lessee_department_name: "",
  lessee_alloted_from_date: "",
  lessee_alloted_to_date: "",
  team_loan: "",
  promoter_contribution_equity: "",
  unsecured_loan: "",
  other_source: "",
  total_amount: "",
  bank_name: "",
  branch_name: "",
  loan_account_number: "",
  senctioned_loan_amount: "",
  loan_approval_date: "",
  total_loan_disbursed_amount: "",
  promoter_name: "",
  promoter_amount: "",
  promoter_pan_number: "",
  promoter_payment_mode: "",
  unsecured_loan_name: "",
  unsecured_loan_amount: "",
  unsecured_loan_pan_number: "",
  unsecured_loan_payment_mode: "",
  major_component_of_infrastructure: "",
  total_area_sqm: "",
  build_up_area: "",
  number_of_rooms: "",
  parking_area: "",
  resuarant_area: "",
  mice_Facilities: "",
  tourist_resort_activities: "",
  resuarant_side_amenities: "",
  developed_facilities_amusement: "",
  any_other_amenities: "",
  electricity_approved_load: "",
  electricity_connected_load: "",
  power_plant_capacity: "",
};

export const incentiveClaimApplicationViewSections = [
  {
    title: {
      en: "Tourism Unit Detail",
      hi: "पर्यटन इकाई का विवरण"
    },
    fields: [
      {
        name: "unit_name",
        label: { en: "Unit Name", hi: "इकाई का नाम" }
      },
      {
        name: "unit_address",
        label: { en: "Unit Address", hi: "इकाई का पता" }
      },
      {
        name: "contact_no",
        label: { en: "Contact Number", hi: "संपर्क नंबर" }
      },
      {
        name: "registered_office",
        label: {
          en: "Registered Office Address",
          hi: "पंजीकृत कार्यालय का पता"
        }
      },
      {
        name: "gst_registration_number",
        label: {
          en: "GST Registration Number",
          hi: "जीएसटी पंजीकरण संख्या"
        }
      },
      {
        name: "travel_registration_date",
        label: {
          en: "Travel Trade Registration Date",
          hi: "ट्रैवल ट्रेड पंजीकरण तिथि"
        }
      },
      {
        name: "uttr_no",
        label: { en: "UTTR Number", hi: "UTTR संख्या" }
      },
      {
        name: "nature_of_organization",
        label: {
          en: "Nature of Organization",
          hi: "संगठन की प्रकृति"
        }
      }
    ],

    subSections: [
      {
        title: {
          en: "Details of Owner(s) / Promoter(s) / Director(s)",
          hi: "मालिक / प्रवर्तक / निदेशक का विवरण"
        },
        fields: [
          {
            name: "investor_details",
            label: {
              en: "Owner/Promoter/Director Details",
              hi: "मालिक / प्रवर्तक / निदेशक विवरण"
            }
          }
        ]
      },

      {
        title: {
          en: "Uttarakhand Bonafide Resident",
          hi: "उत्तराखंड बोनाफाइड निवासी"
        },
        fields: [
          { name: "male_bonafied", label: { en: "Male", hi: "पुरुष" } },
          { name: "female_bonafied", label: { en: "Female", hi: "महिला" } },
          { name: "others_bonafied", label: { en: "Others", hi: "अन्य" } }
        ]
      },

      {
        title: {
          en: "Uttarakhand Non Bonafide Resident",
          hi: "उत्तराखंड गैर-बोनाफाइड निवासी"
        },
        fields: [
          { name: "male_non_bonafied", label: { en: "Male", hi: "पुरुष" } },
          { name: "female_non_bonafied", label: { en: "Female", hi: "महिला" } },
          { name: "others_non_bonafied", label: { en: "Others", hi: "अन्य" } }
        ]
      },

      {
        title: {
          en: "Total",
          hi: "कुल"
        },
        fields: [
          { name: "male_total", label: { en: "Male", hi: "पुरुष" } },
          { name: "female_total", label: { en: "Female", hi: "महिला" } },
          { name: "others_total", label: { en: "Others", hi: "अन्य" } },
          {
            name: "total_permanent_employees",
            label: { en: "Total", hi: "कुल" }
          },
          {
            name: "bonafied_employees_percentage",
            label: {
              en: "% of Bonafide Employees",
              hi: "बोनाफाइड कर्मचारियों का प्रतिशत"
            }
          }
        ]
      }
    ]
  },
  {
    title: {
      en: "Project Details",
      hi: "परियोजना विवरण"
    },
    fields: [],
    subSections: [
      {
        title: {
          en: "General Project Information",
          hi: "सामान्य परियोजना जानकारी"
        },
        fields: [
          {
            name: "project_type",
            label: { en: "Project Type", hi: "परियोजना का प्रकार" }
          },
          {
            name: "area_category",
            label: { en: "Area Category", hi: "क्षेत्र श्रेणी" }
          },
          {
            name: "commercial_operation_date",
            label: {
              en: "Commercial Operation Date (COD)",
              hi: "व्यावसायिक संचालन तिथि (COD)"
            }
          },
          {
            name: "project_category",
            label: { en: "Project Category", hi: "परियोजना श्रेणी" }
          },
          {
            name: "nic_code",
            label: { en: "NIC Code", hi: "NIC कोड" }
          },
          {
            name: "tourism_product_name",
            label: {
              en: "Tourism Product Name",
              hi: "पर्यटन उत्पाद का नाम"
            }
          }
        ]
      },

      {
        title: {
          en: "Land Details",
          hi: "भूमि विवरण"
        },
        fields: [
          {
            name: "land_type",
            label: { en: "Land Type", hi: "भूमि का प्रकार" }
          },
          {
            name: "land_district",
            label: { en: "District", hi: "जिला" }
          },
          {
            name: "land_village",
            label: { en: "Village", hi: "गाँव" }
          },
          {
            name: "land_tehsil",
            label: { en: "Tehsil", hi: "तहसील" }
          },
          {
            name: "mauja",
            label: { en: "Mauja", hi: "मौजा" }
          },
          {
            name: "registeration_allotment_date",
            label: {
              en: "Registration/Allotment Date",
              hi: "पंजीकरण / आवंटन तिथि"
            }
          },
          {
            name: "original_lessee_department_name",
            label: {
              en: "Original Lessee/Department Name",
              hi: "मूल पट्टेदार / विभाग का नाम"
            }
          },
          {
            name: "date_of_allotment_agreement",
            label: {
              en: "Date of Allotment/Agreement",
              hi: "आवंटन / समझौते की तिथि"
            }
          },
          {
            name: "no_of_years",
            label: {
              en: "Lease Period (Years)",
              hi: "पट्टे की अवधि (वर्षों में)"
            }
          }
        ]
      },

      {
        title: {
          en: "Kharsa / Raqwa Details",
          hi: "खसरा / रकबा विवरण"
        },
        fields: [
          {
            name: "kharsa_raqwa_number",
            label: {
              en: "Kharsa/Raqwa Number",
              hi: "खसरा / रकबा संख्या"
            }
          },
          {
            name: "total_land_in_sqm",
            label: {
              en: "Total Land Area (in Sq. m)",
              hi: "कुल भूमि क्षेत्रफल (वर्ग मीटर में)"
            }
          }
        ]
      }
    ]
  },
  {
    title: { hi: "ऋण विवरण", en: "Loan Details" },
    fields: [],
    subSections: [
      {
        title: { hi: "टर्म लोन विवरण", en: "Term Loan Details" },
        fields: [
          {
            name: "term_loan_details",
            label: { hi: "टर्म लोन विवरण", en: "Term Loan Details" },
          },
          {
            name: "term_loan_amount",
            label: { hi: "टर्म लोन राशि", en: "Term Loan Amount" },
          },
        ],
      },
      {
        title: { hi: "प्रमोटर का योगदान (इक्विटी)", en: "Promoter’s Contribution (Equity)" },
        fields: [
          {
            name: "promoters_contribution_details",
            label: { hi: "प्रमोटर योगदान विवरण", en: "Promoter Contribution Details" },
          },
          {
            name: "promoter_contribution_amount",
            label: { hi: "योगदान राशि", en: "Contribution Amount" },
          },
        ],
      },
      {
        title: { hi: "असुरक्षित ऋण", en: "Unsecured Loan" },
        fields: [
          {
            name: "unsecured_loan_details",
            label: { hi: "असुरक्षित ऋण विवरण", en: "Unsecured Loan Details" },
          },
          {
            name: "unsecured_loan_amount",
            label: { hi: "असुरक्षित ऋण राशि", en: "Unsecured Loan Amount" },
          },
        ],
      },
      {
        title: { hi: "अन्य स्रोत", en: "Other Sources" },
        fields: [
          {
            name: "please_specify",
            label: { hi: "अन्य स्रोत विवरण", en: "Other Sources Details" },
          },
        ],
      },
      {
        title: { hi: "बैंक विवरण (परियोजना)", en: "Bank Details (Project)" },
        fields: [
          {
            name: "bank_details_used_for_project",
            label: {
              hi: "परियोजना के लिए उपयोग किए गए बैंक विवरण",
              en: "Bank Details Used for Project",
            },
          },
        ],
      },
      {
        title: { hi: "अधिकृत व्यक्ति विवरण", en: "Authorized Person Details" },
        fields: [
          {
            name: "authorized_person",
            label: { hi: "अधिकृत व्यक्ति", en: "Authorized Person" },
          },
        ],
      },
    ],
  },
  {
    title: { hi: "नीतिगत दिशानिर्देशों के अनुसार न्यूनतम अवसंरचना", en: "Minimum Infra as per Policy Guidelines" },
    fields: [],
    subSections: [
      {
        title: { hi: "अवसंरचना और सुविधाएँ", en: "Infrastructure & Amenities" },
        fields: [
          {
            name: "major_component_of_infrastructure",
            label: { hi: "अवसंरचना के मुख्य घटक", en: "Major Components of Infrastructure" },
          },
          {
            name: "total_area_sqm",
            label: { hi: "कुल क्षेत्रफल (वर्ग मी.)", en: "Total Area (Sq. m)" },
          },
          {
            name: "build_up_area",
            label: { hi: "निर्मित क्षेत्रफल", en: "Built-up Area" },
          },
          {
            name: "number_of_rooms",
            label: { hi: "कक्षों की संख्या", en: "Number of Rooms" },
          },
          {
            name: "parking_area",
            label: { hi: "पार्किंग क्षेत्र", en: "Parking Area" },
          },
          {
            name: "resuarant_area",
            label: { hi: "रेस्टोरेंट क्षेत्र", en: "Restaurant Area" },
          },
          {
            name: "mice_Facilities",
            label: { hi: "MICE सुविधाएँ", en: "MICE Facilities" },
          },
          {
            name: "tourist_resort_activities",
            label: { hi: "पर्यटक रिसॉर्ट गतिविधियाँ", en: "Tourist Resort Activities" },
          },
          {
            name: "resuarant_side_amenities",
            label: { hi: "रेस्टोरेंट-साइड सुविधाएँ", en: "Restaurant-side Amenities" },
          },
          {
            name: "developed_facilities_amusement",
            label: { hi: "विकसित/मनोरंजन सुविधाएँ", en: "Developed/Amusement Facilities" },
          },
          {
            name: "any_other_amenities",
            label: { hi: "अन्य सुविधाएँ", en: "Other Amenities" },
          },
        ],
      },
      {
        title: { hi: "बिजली विवरण", en: "Electricity Details" },
        fields: [
          {
            name: "electricity_approved_load",
            label: { hi: "अनुमोदित लोड (किलोवाट)", en: "Approved Load (kW)" },
          },
          {
            name: "electricity_connected_load",
            label: { hi: "कनेक्टेड लोड (किलोवाट)", en: "Connected Load (kW)" },
          },
          {
            name: "power_plant_capacity",
            label: { hi: "पावर प्लांट क्षमता (किलोवाट)", en: "Power Plant Capacity (kW)" },
          },
        ],
      },
    ],
  },
  {
    title: { hi: "आवश्यक दस्तावेज़", en: "Required Documents" },
    fields: [
      { name: "first_invoice_copy", label: { hi: "पहली चालान की प्रति", en: "First Invoice Copy" } },
      {
        name: "travel_trade_registration_document_cod",
        label: { hi: "ट्रैवल ट्रेड पंजीकरण दस्तावेज़ (COD)", en: "Travel Trade Registration Document (COD)" },
      },
      {
        name: "letter_of_legal_authorized_person",
        label: { hi: "अधिकृत व्यक्ति का पत्र", en: "Letter of Authorized Person" },
      },
      { name: "proof_of_land_ownership", label: { hi: "भूमि स्वामित्व का प्रमाण", en: "Proof of Land Ownership" } },
      { name: "approved_building_plan", label: { hi: "अनुमोदित भवन योजना", en: "Approved Building Plan" } },
      { name: "valid_cto_ukpcb", label: { hi: "UKPCB से वैध CTO", en: "Valid CTO from UKPCB" } },
      {
        name: "completion_occupancy_certificate",
        label: { hi: "समापन/ऑक्यूपेंसी प्रमाणपत्र", en: "Completion/Occupancy Certificate" },
      },
      {
        name: "employee_list_with_id_proof",
        label: { hi: "कर्मचारी सूची (ID प्रमाण के साथ)", en: "Employee List with ID Proof" },
      },
      { name: "incorporation_document", label: { hi: "संस्थागत दस्तावेज़", en: "Incorporation Document" } },
      {
        name: "detailed_project_report",
        label: { hi: "विस्तृत परियोजना रिपोर्ट (DPR)", en: "Detailed Project Report (DPR)" },
      },
      { name: "bank_loan_sanction_letter", label: { hi: "बैंक ऋण स्वीकृति पत्र", en: "Bank Loan Sanction Letter" } },
      {
        name: "photographs_of_the_unit_service",
        label: { hi: "यूनिट/सेवा के फ़ोटो", en: "Photographs of the Unit/Service" },
      },
      { name: "affidavit", label: { hi: "शपथ पत्र", en: "Affidavit" } },
      { name: "gst_registration_document", label: { hi: "GST पंजीकरण दस्तावेज़", en: "GST Registration Document" } },
      { name: "noc_fire_document", label: { hi: "फायर डिपार्टमेंट से NOC", en: "NOC from Fire Department" } },
    ],
  },
  {
    title: { hi: "निवेश विवरण", en: "Investments Details" },
    fields: [],
    subSections: [
      {
        title: { hi: "पूंजी व्यय दस्तावेज़", en: "Capital Expenditure Documents" },
        fields: [
          {
            name: "capital_expenditure_details_excel",
            label: { hi: "पूंजी व्यय विवरण (Excel)", en: "Capital Expenditure Details (Excel)" },
          },
          {
            name: "capital_expenditure_details_pdf",
            label: { hi: "पूंजी व्यय विवरण (PDF)", en: "Capital Expenditure Details (PDF)" },
          },
        ],
      },
      {
        title: { hi: "पूंजी निवेश", en: "Capital Investment" },
        fields: [
          { name: "land_if_admissible", label: { hi: "भूमि (यदि स्वीकार्य)", en: "Land (if admissible)" } },
          { name: "building_civil_works", label: { hi: "भवन/सिविल कार्य", en: "Building/Civil Works" } },
          { name: "plant_machinery", label: { hi: "प्लांट और मशीनरी", en: "Plant & Machinery" } },
          { name: "furniture_fixtures", label: { hi: "फर्नीचर और फिटिंग", en: "Furniture & Fixtures" } },
          {
            name: "utilities_infrastructure",
            label: { hi: "यूटिलिटीज़/इन्फ्रास्ट्रक्चर", en: "Utilities/Infrastructure" },
          },
          { name: "other_expenses", label: { hi: "अन्य खर्चे", en: "Other Expenses" } },
        ],
      },
      {
        title: { hi: "कुल निवेश", en: "Total Investment" },
        fields: [{ name: "total_investment", label: { hi: "कुल निवेश", en: "Total Investment" } }],
      },
      {
        title: { hi: "अयोग्य निवेश", en: "Non-Eligible Investments" },
        fields: [
          {
            name: "expenses_prior_in_principal",
            label: { hi: "प्रधान अनुमोदन से पहले खर्च", en: "Expenses Prior to Principal Approval" },
          },
          {
            name: "expenses_no_bills_after_in_principal",
            label: { hi: "बिल के बिना खर्च / प्रधान के बाद खर्च", en: "Expenses without Bills/After Principal" },
          },
          {
            name: "expenses_paid_cash_other",
            label: { hi: "कैश भुगतान/अन्य खर्च", en: "Cash Payments/Other Expenses" },
          },
          {
            name: "cost_land_stamp_duty",
            label: { hi: "भूमि की लागत/स्टाम्प ड्यूटी", en: "Cost of Land/Stamp Duty" },
          },
          {
            name: "cost_consultancy_other_taxes",
            label: { hi: "कंसल्टेंसी/अन्य कर", en: "Consultancy/Other Taxes" },
          },
          {
            name: "site_development_valuation",
            label: { hi: "साइट विकास/मूल्यांकन", en: "Site Development/Valuation" },
          },
        ],
      },
      {
        title: { hi: "कुल अयोग्य राशि", en: "Total Non-Eligible Amount" },
        fields: [
          {
            name: "total_non_eligible",
            label: { hi: "कुल अयोग्य राशि", en: "Total Non-Eligible Amount" },
          },
        ],
      },
      {
        title: { hi: "योग्य निवेश", en: "Eligible Investment" },
        fields: [
          {
            name: "total_eligible_investment_after_non_eligible_deduction",
            label: { hi: "कुल योग्य निवेश (कटौती के बाद)", en: "Total Eligible Investment (Post Deduction)" },
          },
        ],
      },
      {
        title: { hi: "अनुमानित पूंजी सब्सिडी", en: "Tentative Capital Subsidy" },
        fields: [
          {
            name: "capital_subsidy_min_investment",
            label: { hi: "न्यूनतम पूंजी सब्सिडी", en: "Minimum Capital Subsidy" },
          },
          {
            name: "capital_subsidy_additional_investment",
            label: { hi: "अतिरिक्त पूंजी सब्सिडी", en: "Additional Capital Subsidy" },
          },
          {
            name: "total_max_capital_subsidy",
            label: { hi: "अधिकतम पूंजी सब्सिडी", en: "Maximum Capital Subsidy" },
          },
        ],
      },
      {
        title: { hi: "पूंजी सब्सिडी दस्तावेज़", en: "Capital Subsidy Documents" },
        fields: [
          { name: "ca_certificate_capex", label: { hi: "CA प्रमाणपत्र (CapEx)", en: "CA Certificate (CapEx)" } },
          {
            name: "actual_bills_capex",
            label: { hi: "वास्तविक बिल (CapEx)", en: "Actual Bills (CapEx)" },
          },
          {
            name: "bank_transaction_proof_1",
            label: { hi: "बैंक लेनदेन प्रमाण 1", en: "Bank Transaction Proof 1" },
          },
          {
            name: "bank_transaction_proof_2",
            label: { hi: "बैंक लेनदेन प्रमाण 2", en: "Bank Transaction Proof 2" },
          },
          {
            name: "bank_transaction_proof_3",
            label: { hi: "बैंक लेनदेन प्रमाण 3", en: "Bank Transaction Proof 3" },
          },
          {
            name: "bank_transaction_proof_4",
            label: { hi: "बैंक लेनदेन प्रमाण 4", en: "Bank Transaction Proof 4" },
          },
          {
            name: "bank_transaction_proof_5",
            label: { hi: "बैंक लेनदेन प्रमाण 5", en: "Bank Transaction Proof 5" },
          },
          {
            name: "chartered_engineer_certificate",
            label: { hi: "चार्टर्ड इंजीनियर प्रमाणपत्र", en: "Chartered Engineer Certificate" },
          },
        ],
      },
    ],
  },
  {
    title: { hi: "ब्याज सब्सिडी", en: "Interest Subsidy" },
    fields: [],
    subSections: [
      {
        title: {
          hi: "ब्याज सब्सिडी (पहली किस्त) के लिए बैंक विवरण",
          en: "Bank Details Section for Interest Subsidy First Installment",
        },
        fields: [
          {
            name: "loan_interest_details_interest_subsidy_first_installment",
            label: { hi: "ऋण ब्याज विवरण (पहली किस्त)", en: "Loan Interest Details (First Installment)" },
          },
          {
            name: "total_interest_paid_first_installment",
            label: { hi: "पहली किस्त में कुल भुगतान किया गया ब्याज", en: "Total Interest Paid in First Installment" },
          },
          {
            name: "maximum_eligible_amount_first_installment",
            label: { hi: "अधिकतम पात्र राशि", en: "Maximum Eligible Amount" },
          },
        ],
      },
      {
        title: {
          hi: "ब्याज सब्सिडी (दूसरी किस्त) के लिए बैंक विवरण",
          en: "Bank Details Section for Interest Subsidy Second Installment",
        },
        fields: [
          {
            name: "loan_interest_details_interest_subsidy_second_installment",
            label: { hi: "ऋण ब्याज विवरण (दूसरी किस्त)", en: "Loan Interest Details (Second Installment)" },
          },
          {
            name: "total_interest_paid_second_installment",
            label: { hi: "दूसरी किस्त में कुल भुगतान किया गया ब्याज", en: "Total Interest Paid in Second Installment" },
          },
          {
            name: "maximum_eligible_amount_second_installment",
            label: { hi: "अधिकतम पात्र राशि", en: "Maximum Eligible Amount" },
          },
        ],
      },
      {
        title: {
          hi: "ब्याज सब्सिडी (तीसरी किस्त) के लिए बैंक विवरण",
          en: "Bank Details Section for Interest Subsidy Third Installment",
        },
        fields: [
          {
            name: "loan_interest_details_interest_subsidy_third_installment",
            label: { hi: "ऋण ब्याज विवरण (तीसरी किस्त)", en: "Loan Interest Details (Third Installment)" },
          },
          {
            name: "total_interest_paid_third_installment",
            label: { hi: "तीसरी किस्त में कुल भुगतान किया गया ब्याज", en: "Total Interest Paid in Third Installment" },
          },
          {
            name: "maximum_eligible_amount_third_installment",
            label: { hi: "अधिकतम पात्र राशि", en: "Maximum Eligible Amount" },
          },
        ],
      },
      {
        title: { hi: "ब्याज सब्सिडी दस्तावेज़", en: "Interest Subsidy Documents" },
        fields: [
          {
            name: "bank_financial_institution_loan_sanction_letter",
            label: {
              hi: "बैंक/वित्तीय संस्था का ऋण स्वीकृति पत्र (केवल NBFCs और अनुसूचित बैंक)",
              en: "Bank / financial Institution’s loan sanction letter (only NBFCs and Scheduled Banks)",
            },
          },
          {
            name: "proof_payment_interest_principal_bank",
            label: {
              hi: "बैंक को ब्याज और मूलधन भुगतान का प्रमाण",
              en: "Proof of payment of interest and principal amount to bank",
            },
          },
          {
            name: "bank_certificate_annual_interest_payment",
            label: {
              hi: "वार्षिक ब्याज भुगतान का बैंक प्रमाण पत्र और नो डिफ़ॉल्ट प्रमाण पत्र",
              en: "Bank certificate stating annual interest payment and Bank Certificate for No Default & towards repayment of loan",
            },
          },
        ],
      },
    ],
  },
  {
    title: { hi: "स्टाम्प ड्यूटी", en: "Stamp Duty" },
    fields: [],
    subSections: [
      {
        title: { hi: "स्टाम्प ड्यूटी भुगतान विवरण", en: "Stamp Duty Payment Details" },
        fields: [
          {
            name: "stamp_duty_for_first_installment_details",
            label: { hi: "पहली किस्त के स्टाम्प ड्यूटी विवरण", en: "" },
          }
        ],
      },
      {
        title: { hi: "कुल स्टाम्प ड्यूटी भुगतान", en: "Total Stamp Duty Paid" },
        fields: [
          {
            name: "total_stamp_duty_per_year",
            label: { hi: "प्रति वर्ष कुल स्टाम्प ड्यूटी", en: "Total Stamp Duty per Year" },
          },
        ],
      },
      {
        title: { hi: "स्टाम्प ड्यूटी दस्तावेज़", en: "Stamp Duty Documents" },
        fields: [
          {
            name: "pde_number_detail",
            label: { hi: "PDE नंबर विवरण", en: "PDE Number" },
          },
          {
            name: "bank_proof_stamp_duty",
            label: { hi: "स्टाम्प ड्यूटी का बैंक प्रमाण", en: "Bank Proof of Stamp Duty" },
          },
          {
            name: "loan_agreement_or_mortgaged_deed",
            label: { hi: "ऋण अनुबंध/बंधक डीड", en: "Loan Agreement/Mortgaged Deed" },
          },
        ],
      },
      {
        title: { hi: "कर दस्तावेज़", en: "Tax Documents" },
        fields: [
          {
            name: "itr_return_file_second_installment",
            label: { hi: "ITR रिटर्न फ़ाइल", en: "ITR Return File" },
          },
          {
            name: "gst_return_file_second_installment",
            label: { hi: "GST रिटर्न फ़ाइल", en: "GST Return File" },
          },
          {
            name: "electricity_bill_last_six_months_second_installment",
            label: { hi: "बिजली बिल (पिछले छह महीने)", en: "Electricity Bill (last six Month)" },
          },
        ],
      },
      {
        title: { hi: "सब्सिडी भुगतान के लिए बैंक विवरण", en: "Bank Details for Subsidy Disbursement" },
        fields: [
          {
            name: "subsidy_ifsc_code",
            label: { hi: "IFSC कोड", en: "IFSC Code" },
          },
          {
            name: "subsidy_bank_name",
            label: { hi: "बैंक का नाम", en: "Bank Name" },
          },
          {
            name: "subsidy_branch_name",
            label: { hi: "शाखा का नाम", en: "Branch Name" },
          },
          {
            name: "subsidy_bank_account_number",
            label: { hi: "बैंक खाता नंबर", en: "Bank Account Number" },
          },
        ],
      },
      {
        title: { hi: "बैंक दस्तावेज़", en: "Bank Document" },
        fields: [
          {
            name: "photocopy_bank_passbook_cancelled_check",
            label: { hi: "बैंक पासबुक/रद्द चेक", en: "Bank Passbook/Cancelled Cheque" },
          },
        ],
      },
    ],
  },
];

export const recommenedInvestment = {
  capitalSubsidy: {
    name: "recommended_investment",
    label: {
      hi: "अनुशंसित योग्य निवेश",
      en: "Recommended Eligible Investment",
    },
  },
  capitalSubsidySecondInstallment: {
    name: "recommended_capital_subsidy_second_installment",
    label: {
      hi: "अनुशंसित पूंजी सब्सिडी (दूसरी किस्त)",
      en: "Recommended Capital Subsidy Second Installment",
    },
  },
  stampDuty: {
    name: "stamp_duty_recommended_investment",
    label: {
      hi: "अनुशंसित स्टाम्प ड्यूटी",
      en: "Recommended Stamp Duty",
    },
  },
  interestSubsidyFirstInstallment: {
    name: "recommended_interest_subsidy_first_installment",
    label: {
      hi: "अनुशंसित ब्याज सब्सिडी (पहली किस्त)",
      en: "Recommended Interest Subsidy First Installment",
    },
  },
  interestSubsidySecondInstallment: {
    name: "recommended_interest_subsidy_second_installment",
    label: {
      hi: "अनुशंसित ब्याज सब्सिडी (दूसरी किस्त)",
      en: "Recommended Interest Subsidy Second Installment",
    },
  },
  interestSubsidyThirdInstallment: {
    name: "recommended_interest_subsidy_third_installment",
    label: {
      hi: "अनुशंसित ब्याज सब्सिडी (तीसरी किस्त)",
      en: "Recommended Interest Subsidy Third Installment",
    },
  },
};

export const adminViewSections = {
  capitalSubsidyFirstInstallment: {
    title: {
      hi: "पूंजी सब्सिडी",
      en: "Capital Subsidy",
    },
    subSections: [
      {
        title: {
          hi: "कुल योग्य निवेश (गैर-योग्य कटौती के बाद)",
          en: "Total Eligible Investment (After deduction of non-eligible)",
        },
        fields: [
          {
            name: "total_eligible_investment_after_non_eligible_deduction",
            label: {
              hi: "कुल योग्य निवेश",
              en: "Total Eligible Investment",
            },
          },
          {
            name: "recommended_investment",
            label: {
              hi: "अनुशंसित योग्य निवेश",
              en: "Recommended Eligible Investment",
            },
          },
        ],
      },
      {
        title: {
          hi: "अनुमानित पूंजी सब्सिडी",
          en: "Tentative Capital Subsidy",
        },
        fields: [
          {
            name: "capital_subsidy_min_investment",
            label: {
              hi: "न्यूनतम निवेश के लिए पूंजी सब्सिडी (1 करोड़)",
              en: "Capital Subsidy For Min Investment (1 Cr.)",
            },
          },
          {
            name: "capital_subsidy_additional_investment",
            label: {
              hi: "अतिरिक्त निवेश के लिए पूंजी सब्सिडी (<1 & >5Cr.)",
              en: "Capital Subsidy For Additional Investment (<1 & >5Cr.)",
            },
          },
          {
            name: "total_max_capital_subsidy",
            label: {
              hi: "कुल अधिकतम पूंजी सब्सिडी",
              en: "Total Maximum Capital Subsidy",
            },
          },
        ],
      },
    ],
  },

  capitalSubsidySecondInstallment: {
    title: {
      hi: "पूंजी सब्सिडी",
      en: "Capital Subsidy",
    },
    subSections: [
      {
        title: {
          hi: "पूंजी सब्सिडी विवरण",
          en: "Capital Subsidy Details",
        },
        fields: [
          {
            name: "total_eligible_investment_after_non_eligible_deduction",
            label: {
              hi: "अनुमोदित योग्य निवेश",
              en: "Approved Eligible Investment",
            },
          },
          {
            name: "total_max_capital_subsidy",
            label: {
              hi: "अनुमोदित अधिकतम पूंजी सब्सिडी",
              en: "Approved Maximum Capital Subsidy",
            },
          },
          {
            name: "disbursed_capital_subsidy_first_installment",
            label: {
              hi: "पहली किस्त - वितरित पूंजी सब्सिडी",
              en: "Disbursed Capital Subsidy - First Installment",
            },
          },
          {
            name: "disbursed_date_capital_subsidy_first_installment",
            label: {
              hi: "पहली किस्त का वितरण तिथि",
              en: "Disbursed Date - Capital Subsidy First Installment",
            },
          },
          {
            name: "remaining_capital_subsidy_second_installment",
            label: {
              hi: "दूसरी किस्त के लिए शेष पूंजी सब्सिडी",
              en: "Remaining Capital Subsidy Second Installment",
            },
          },
          {
            name: "recommended_capital_subsidy_second_installment",
            label: {
              hi: "अनुशंसित पूंजी सब्सिडी (दूसरी किस्त)",
              en: "Recommended Capital Subsidy Second Installment",
            },
          },
        ],
      },
    ],
  },

  stampDuty: {
    title: {
      hi: "स्टाम्प ड्यूटी",
      en: "Stamp Duty",
    },
    subSections: [
      {
        title: {
          hi: "कुल योग्य निवेश (गैर-योग्य कटौती के बाद)",
          en: "Total Eligible Investment (After deduction of non-eligible)",
        },
        fields: [
          {
            name: "total_stamp_duty_per_year",
            label: {
              hi: "प्रति वर्ष कुल स्टाम्प ड्यूटी (INR)",
              en: "Total Stamp Duty Paid Per Year (INR)",
            },
          },
          {
            name: "stamp_duty_recommended_investment",
            label: {
              hi: "अनुशंसित स्टाम्प ड्यूटी",
              en: "Recommended Stamp Duty",
            },
          },
        ],
      },
    ],
  },

  interestSubsidyFirstInstallment: {
    title: {
      hi: "ब्याज सब्सिडी - पहली किस्त",
      en: "Interest Subsidy - First Installment",
    },
    subSections: [
      {
        title: {
          hi: "पहली किस्त के लिए ब्याज सब्सिडी बैंक विवरण",
          en: "Bank Details Section for Interest Subsidy First Installment",
        },
        fields: [
          {
            name: "loan_interest_details_interest_subsidy_first_installment",
            label: { hi: "", en: "" },
          },
          {
            name: "total_interest_paid_first_installment",
            label: {
              hi: "पहली किस्त में कुल भुगतान किया गया ब्याज",
              en: "Total Interest Paid in First Installment",
            },
          },
          {
            name: "maximum_eligible_amount_first_installment",
            label: {
              hi: "अधिकतम पात्र राशि",
              en: "Maximum Eligible Amount",
            },
          },
          {
            name: "recommended_interest_subsidy_first_installment",
            label: {
              hi: "अनुशंसित ब्याज सब्सिडी (पहली किस्त)",
              en: "Recommended Interest Subsidy First Installment",
            },
          },
        ],
      },
    ],
  },

  interestSubsidySecondInstallment: {
    title: {
      hi: "ब्याज सब्सिडी - दूसरी किस्त",
      en: "Interest Subsidy - Second Installment",
    },
    subSections: [
      {
        title: {
          hi: "दूसरी किस्त के लिए ब्याज सब्सिडी बैंक विवरण",
          en: "Bank Details Section for Interest Subsidy Second Installment",
        },
        fields: [
          {
            name: "loan_interest_details_interest_subsidy_second_installment",
            label: { hi: "", en: "" },
          },
          {
            name: "total_interest_paid_second_installment",
            label: {
              hi: "दूसरी किस्त में कुल भुगतान किया गया ब्याज",
              en: "Total Interest Paid in Second Installment",
            },
          },
          {
            name: "maximum_eligible_amount_second_installment",
            label: {
              hi: "अधिकतम पात्र राशि",
              en: "Maximum Eligible Amount",
            },
          },
          {
            name: "recommended_interest_subsidy_second_installment",
            label: {
              hi: "अनुशंसित ब्याज सब्सिडी (दूसरी किस्त)",
              en: "Recommended Interest Subsidy Second Installment",
            },
          },
        ],
      },
    ],
  },

  interestSubsidyThirdInstallment: {
    title: {
      hi: "ब्याज सब्सिडी - तीसरी किस्त",
      en: "Interest Subsidy - Third Installment",
    },
    subSections: [
      {
        title: {
          hi: "तीसरी किस्त के लिए ब्याज सब्सिडी बैंक विवरण",
          en: "Bank Details Section for Interest Subsidy Third Installment",
        },
        fields: [
          {
            name: "loan_interest_details_interest_subsidy_third_installment",
            label: { hi: "", en: "" },
          },
          {
            name: "total_interest_paid_third_installment",
            label: {
              hi: "तीसरी किस्त में कुल भुगतान किया गया ब्याज",
              en: "Total Interest Paid in Third Installment",
            },
          },
          {
            name: "maximum_eligible_amount_third_installment",
            label: {
              hi: "अधिकतम पात्र राशि",
              en: "Maximum Eligible Amount",
            },
          },
          {
            name: "recommended_interest_subsidy_third_installment",
            label: {
              hi: "अनुशंसित ब्याज सब्सिडी (तीसरी किस्त)",
              en: "Recommended Interest Subsidy Third Installment",
            },
          },
        ],
      },
    ],
  },
};

export const columnLabelMapper = {
  name: {
    en: "Name",
    hi: "नाम",
  },
  designation: {
    en: "Designation",
    hi: "पद",
  },
  gender: {
    en: "Gender",
    hi: "लिंग",
  },
  share_holding: {
    en: "Share Holding",
    hi: "शेयर होल्डिंग",
  },
  mobile_number: {
    en: "Mobile Number",
    hi: "मोबाइल नंबर",
  },
  pan_number: {
    en: "PAN Number",
    hi: "पैन नंबर",
  },
  uttarakhandi_resident: {
    en: "Uttarakhand Resident",
    hi: "उत्तराखंड निवासी",
  },
  uttarakhandi_resident_document: {
    en: "Uttarakhand Resident Certificate",
    hi: "उत्तराखंड निवासी प्रमाण पत्र",
  },
  khasra_no: {
    en: "Khasra Number",
    hi: "खसरा नंबर",
  },
  raqwa_in_hectares: {
    en: "Area in Hectares",
    hi: "रकबा (हेक्टेयर में)",
  },
  area_in_sqm: {
    en: "Area in Square Meter",
    hi: "क्षेत्रफल (वर्ग मीटर में)",
  },
  bank_name: {
    en: "Bank Name",
    hi: "बैंक का नाम",
  },
  branch_name: {
    en: "Branch Name",
    hi: "शाखा का नाम",
  },
  loan_account_number: {
    en: "Loan Account Number",
    hi: "ऋण खाता संख्या",
  },
  sanctioned_loan_amount: {
    en: "Sanctioned Loan Amount",
    hi: "स्वीकृत ऋण राशि",
  },
  sanction_date: {
    en: "Sanction Date",
    hi: "स्वीकृति की तिथि",
  },
  first_instalment_disbursal_date: {
    en: "First Installment Disbursal Date",
    hi: "प्रथम किस्त वितरण तिथि",
  },
  total_loan_disbursed_amount: {
    en: "Total Loan Disbursed Amount",
    hi: "कुल वितरित ऋण राशि",
  },
  ifsc_code: {
    en: "IFSC Code",
    hi: "आईएफएससी कोड",
  },
  name_of_the_promoter: {
    en: "Name of the Promoter",
    hi: "प्रवर्तक का नाम",
  },
  amount: {
    en: "Amount",
    hi: "राशि",
  },
  pan_number: {
    en: "PAN Number",
    hi: "पैन संख्या",
  },
  mode_of_payment: {
    en: "Mode of Payment",
    hi: "भुगतान का माध्यम",
  },
  name_of_bank: {
    en: "Name of Bank",
    hi: "बैंक का नाम",
  },
  branch_name: {
    en: "Branch Name",
    hi: "शाखा का नाम",
  },
  account_holder_name: {
    en: "Account Holder Name",
    hi: "खाता धारक का नाम",
  },
  ifsc_code: {
    en: "IFSC Code",
    hi: "आईएफएससी कोड",
  },
  bank_account_number: {
    en: "Bank Account Number",
    hi: "बैंक खाता संख्या",
  },
  bank_account_type: {
    en: "Bank Account Type",
    hi: "बैंक खाता प्रकार",
  },
  name: {
    en: "Name",
    hi: "नाम",
  },
  email_address: {
    en: "Email Address",
    hi: "ईमेल पता",
  },
  mobile_number: {
    en: "Mobile Number",
    hi: "मोबाइल नंबर",
  },
  bank_name: {
    en: "Bank Name",
    hi: "बैंक का नाम",
  },
  branch_name: {
    en: "Branch Name",
    hi: "शाखा का नाम",
  },
  loan_account_number: {
    en: "Loan Account Number",
    hi: "ऋण खाता संख्या",
  },
  sanctioned_loan_amount: {
    en: "Sanctioned Loan Amount",
    hi: "स्वीकृत ऋण राशि",
  },
  sanction_date: {
    en: "Sanction Date",
    hi: "स्वीकृति तिथि",
  },
  first_instalment_disbursal_date: {
    en: "First Installment Disbursal Date",
    hi: "प्रथम किस्त जारी करने की तिथि",
  },
  total_loan_disbursed_amount: {
    en: "Total Loan Disbursed Amount",
    hi: "कुल वितरित ऋण राशि",
  },
  ifsc_code: {
    en: "IFSC Code",
    hi: "आईएफएससी कोड",
  },
  pde_no: {
    en: "PDE Number",
    hi: "पीडीई संख्या",
  },
  khatoni: {
    en: "Khatoni",
    hi: "खतौनी",
  },
  khasra: {
    en: "Khasra",
    hi: "खसरा",
  },
  district: {
    en: "District",
    hi: "जिला",
  },
  location: {
    en: "Location",
    hi: "स्थान",
  },
  buyer: {
    en: "Buyer",
    hi: "खरीदार",
  },
  seller: {
    en: "Seller",
    hi: "विक्रेता",
  },
  stamp_duty: {
    en: "Stamp Duty",
    hi: "स्टाम्प शुल्क",
  },
  regdate: {
    en: "Registration Date",
    hi: "पंजीकरण तिथि",
  },
  bank_name: {
    en: "Bank Name",
    hi: "बैंक का नाम",
  },
  account_number: {
    en: "Account Number",
    hi: "खाता संख्या",
  },
  account_holder_name: {
    en: "Account Holder Name",
    hi: "खाता धारक का नाम",
  },
  loan_disbursed_amount: {
    en: "Loan Disbursed Amount",
    hi: "वितरित ऋण राशि",
  },
  interest_start_date: {
    en: "Interest Start Date",
    hi: "ब्याज प्रारंभ तिथि",
  },
  interest_end_date: {
    en: "Interest End Date",
    hi: "ब्याज समाप्ति तिथि",
  },
  principal_paid: {
    en: "Principal Amount Paid",
    hi: "चुकाई गई मूलधन राशि",
  },
  interest_paid: {
    en: "Interest Paid",
    hi: "चुकाया गया ब्याज",
  },
  panel_amount: {
    en: "Penal Amount",
    hi: "दंडात्मक राशि",
  },
  total_interest: {
    en: "Total Interest",
    hi: "कुल ब्याज",
  },
  payment_date: {
    en: "Payment Date",
    hi: "भुगतान तिथि",
  },
};


